/* ═══════════════════════════════════════════════════════
   SR CHAMPIONS — Portal de Participantes
   Soccer Revolution · Champions League 2026/27
═══════════════════════════════════════════════════════ */

/* ── Configuración Firebase ───────────────────────────── */
const CH_FIREBASE_CONFIG = {
  apiKey: "AIzaSyDdl5WQHtTN2wTMOvLKFWLgJBXZ9Xbz-7c",
  authDomain: "soccer-revolution-champions.firebaseapp.com",
  projectId: "soccer-revolution-champions",
  storageBucket: "soccer-revolution-champions.firebasestorage.app",
  messagingSenderId: "553292595830",
  appId: "1:553292595830:web:44fdb13c783db206fb9557"
};

/* ── Datos del torneo ─────────────────────────────────── */
const CH_DATA = {
  fases: [
    { id: 'liga',      nombre: 'FASE DE LIGA',     tipo: 'liga',
      puntos: { resultado: 2, exacto: 7, anotador: 2 } },
    { id: 'playoff',   nombre: 'PLAYOFF',           tipo: 'eliminatoria',
      puntos: { resultado: 4, exacto: 10, anotador: 3 } },
    { id: 'octavos',   nombre: '8VOS DE FINAL',     tipo: 'eliminatoria',
      puntos: { resultado: 6, exacto: 15, anotador: 4 } },
    { id: 'cuartos',   nombre: 'CUARTOS DE FINAL',  tipo: 'eliminatoria',
      puntos: { resultado: 10, exacto: 22, anotador: 5 } },
    { id: 'semifinal', nombre: 'SEMIFINALES',        tipo: 'eliminatoria',
      puntos: { resultado: 15, exacto: 32, anotador: 8 } },
    { id: 'final',     nombre: 'GRAN FINAL',         tipo: 'final',
      puntos: { resultado: 22, exacto: 60, anotador: 10 } }
  ],
  rachas: [
    { n: 3,  bonus: 5  },
    { n: 5,  bonus: 15 },
    { n: 8,  bonus: 35 },
    { n: 12, bonus: 70 }
  ],
  termometro: [
    { pts: 100,  nivel: 1, label: '5% Descuento',              icon: '🥉', color: '#cd7f32' },
    { pts: 280,  nivel: 2, label: '10% Descuento',             icon: '🥈', color: '#aaa'    },
    { pts: 550,  nivel: 3, label: '15% Descuento',             icon: '🥇', color: '#FF1464' },
    { pts: 900,  nivel: 4, label: '20% Desc. + Accesorio SR',  icon: '💎', color: '#60a5fa' },
    { pts: 1400, nivel: 5, label: 'Camisola Champions (Q525)', icon: '👑', color: '#FF1464' }
  ],
  medallas: [
    { id: 'primer_acierto',  icon: '⚽', nombre: 'Primer Acierto',     desc: 'Acertá tu primer resultado',       check: (s) => s.correct >= 1 },
    { id: 'exacto',          icon: '🎯', nombre: 'Ojo de Halcón',      desc: 'Predecí un marcador exacto',       check: (s) => s.exactos >= 1 },
    { id: 'racha3',          icon: '🔥', nombre: 'En Llamas',           desc: 'Lográ una racha de 3 aciertos',   check: (s) => s.maxStreak >= 3 },
    { id: 'racha5',          icon: '💥', nombre: 'Imparable',           desc: 'Racha de 5 aciertos',             check: (s) => s.maxStreak >= 5 },
    { id: 'racha8',          icon: '⚡', nombre: 'Relámpago',           desc: 'Racha de 8 aciertos',             check: (s) => s.maxStreak >= 8 },
    { id: 'nivel2',          icon: '🥈', nombre: 'Plata',               desc: 'Alcanzá 280 puntos',              check: (s) => s.pts >= 280 },
    { id: 'nivel3',          icon: '🥇', nombre: 'Oro',                 desc: 'Alcanzá 550 puntos',              check: (s) => s.pts >= 550 },
    { id: 'nivel4',          icon: '💎', nombre: 'Diamante',            desc: 'Alcanzá 900 puntos',              check: (s) => s.pts >= 900 },
    { id: 'campeon',         icon: '👑', nombre: 'Campeón SR',          desc: 'Alcanzá 1400 puntos',             check: (s) => s.pts >= 1400 },
    { id: '5exactos',        icon: '🏹', nombre: 'Tirador de Élite',    desc: 'Logra 5 marcadores exactos',      check: (s) => s.exactos >= 5 },
    { id: 'final_pred',      icon: '🏆', nombre: 'Predictor de Final',  desc: 'Vaticiná la Gran Final',          check: (s) => s.finalPredicted },
    { id: 'full_jornada',    icon: '📋', nombre: 'Comprometido',        desc: 'Completá una jornada entera',     check: (s) => s.fullJornada }
  ]
};

const CH_ADMIN_EMAIL = 'soccerrevolution.gt21@gmail.com';

/* ── Puntos por fase, indexado por la clave corta que usa el admin
   ('league','playoff','r16','qf','sf','final') en matches[].phase ──── */
const CH_PHASE_PTS_BY_KEY = {
  league:  { resultado:2,  exacto:7,  anotador:2  },
  playoff: { resultado:4,  exacto:10, anotador:3  },
  r16:     { resultado:6,  exacto:15, anotador:4  },
  qf:      { resultado:10, exacto:22, anotador:5  },
  sf:      { resultado:15, exacto:32, anotador:8  },
  final:   { resultado:22, exacto:60, anotador:10 }
};

// Puntos base (resultado + exacto + anotador) de UN partido puntual, sin bono de
// racha — ese bono depende del orden cronológico de TODOS los partidos y solo se
// calcula de forma agregada en _renderMisStats. Se usa para el feedback inline
// en la tarjeta de partido una vez que ya tiene resultado cargado.
function _chBasePoints(pred, m, phaseKey) {
  if (!pred) return 0;
  const cfg = CH_PHASE_PTS_BY_KEY[phaseKey] || CH_PHASE_PTS_BY_KEY.league;
  // OJO: m.local/m.visitante son los campos de NOMBRE de equipo en este objeto
  // (ver homeTeam = m.homeTeamName || m.local || ...), no son marcadores — no
  // deben estar en esta cadena de respaldo de puntaje. Antes, si faltaba
  // homeScore, esto intentaba Number("Real Madrid") = NaN, y nunca llegaba al
  // verdadero campo legado localScore.
  const rH = Number(m.homeScore  ?? m.localScore);
  const rA = Number(m.awayScore  ?? m.visitanteScore);
  const pH = Number(pred.homeScore ?? pred.localScore);
  const pA = Number(pred.awayScore ?? pred.visitanteScore);
  if (isNaN(rH) || isNaN(rA) || isNaN(pH) || isNaN(pA)) return 0;
  const realRes = rH > rA ? 'H' : rH < rA ? 'A' : 'D';
  const predRes = pH > pA ? 'H' : pH < pA ? 'A' : 'D';
  if (predRes !== realRes) return 0;
  let pts = cfg.resultado;
  if (pH === rH && pA === rA) pts += cfg.exacto;
  const pf = pred.firstScoringTeam, rf = m.firstScoringTeam;
  if (pf && rf && pf === rf) pts += cfg.anotador;
  return pts;
}

/* ── Animation Helpers ────────────────────────────────── */
function chCountUp(el, target, duration) {
  if (!el || target === 0) { if (el) el.textContent = '0'; return; }
  const start = Date.now();
  const from  = 0;
  (function tick() {
    const progress = Math.min((Date.now() - start) / duration, 1);
    const ease = 1 - Math.pow(1 - progress, 4);
    el.textContent = Math.round(from + (target - from) * ease);
    if (progress < 1) requestAnimationFrame(tick);
    else { el.textContent = target; el.classList.add('popped'); setTimeout(() => el.classList.remove('popped'), 400); }
  })();
}

function chRipple(e, el) {
  const btn  = el || e.currentTarget;
  const rect = btn.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height) * 2.2;
  const x = (e.clientX - rect.left) - size / 2;
  const y = (e.clientY - rect.top)  - size / 2;
  const rip = document.createElement('span');
  rip.className = 'ch-ripple';
  rip.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + x + 'px;top:' + y + 'px';
  btn.appendChild(rip);
  setTimeout(() => rip.remove(), 600);
}

function chInitRipples(root) {
  (root || document).querySelectorAll(
    '.sr-ch-btn,.sr-ch-btn-primary,.sr-ch-save-btn,.sr-ch-jornada-tab,.sr-ch-qual-btn,.sr-ch-scorer-btn'
  ).forEach(el => {
    if (el._rippleInit) return;
    el._rippleInit = true;
    el.addEventListener('click', e => chRipple(e, el));
  });
}

function chInitTilt(root) {
  (root || document).querySelectorAll('.sr-ch-access-card,.sr-ch-stats-kpi,.sr-ch-pcard').forEach(card => {
    if (card._tiltInit) return;
    card._tiltInit = true;
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width  - .5;
      const y = (e.clientY - r.top)  / r.height - .5;
      card.style.transform = 'perspective(600px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) translateY(-3px)';
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
}

/* ── Bandera de equipo: imagen real en vez de emoji ──────
   Windows (Chrome/Edge de escritorio) no trae fuente con glifos de bandera
   por región — un emoji como 🇪🇸 se ve como las letras sueltas "ES", y
   banderas compuestas (subdivisión, ej. Inglaterra) se rompen todavía peor.
   Si el texto guardado son exactamente 2 "regional indicator symbols" (un
   código de país simple), lo convertimos a imagen real vía flagcdn.com —
   se ve igual en cualquier sistema operativo. Cualquier otro emoji/texto
   (⚽, escudos como texto, etc.) se muestra tal cual, sin tocarlo. ── */
function chFlagHTML(flag, px) {
  px = px || 40;
  const raw = String(flag || '⚽');
  const chars = Array.from(raw);
  const isRegionalPair = chars.length === 2 && chars.every(c => {
    const cp = c.codePointAt(0);
    return cp >= 0x1F1E6 && cp <= 0x1F1FF;
  });
  if (!isRegionalPair) return chEscape(raw);
  const cc = chars.map(c => String.fromCharCode(c.codePointAt(0) - 0x1F1E6 + 65)).join('').toLowerCase();
  const h = Math.round(px * 0.72);
  return '<span style="display:inline-block;vertical-align:middle">' +
    '<img src="https://flagcdn.com/' + cc + '.svg" alt="' + chEscape(raw) + '" width="' + px + '" height="' + h + '" ' +
      'style="width:' + px + 'px;height:' + h + 'px;object-fit:cover;border-radius:4px;box-shadow:0 1px 5px rgba(0,0,0,.35);vertical-align:middle;display:inline-block" ' +
      'onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'inline\'">' +
    '<span style="display:none;font-size:' + px + 'px;line-height:1">' + chEscape(raw) + '</span>' +
  '</span>';
}

/* ── Escudo del club (si existe) con respaldo a la bandera de país ──
   Igual patrón que chFlagHTML: si la imagen del escudo falla (fuente
   externa, no un CDN propio), cae automáticamente a chFlagHTML() en vez
   de mostrar un ícono roto. */
function chBadgeHTML(crestUrl, flag, px) {
  px = px || 40;
  if (!crestUrl) return chFlagHTML(flag, px);
  const fallback = chFlagHTML(flag, px);
  return '<span style="display:inline-block;vertical-align:middle">' +
    '<img src="' + chEscape(crestUrl) + '" alt="" width="' + px + '" height="' + px + '" ' +
      'style="width:' + px + 'px;height:' + px + 'px;object-fit:contain;vertical-align:middle;display:inline-block;filter:drop-shadow(0 1px 3px rgba(0,0,0,.4))" ' +
      'onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'inline-block\'">' +
    '<span style="display:none">' + fallback + '</span>' +
  '</span>';
}

/* ── Helpers ──────────────────────────────────────────── */
function chEscape(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ── Estado de carga en botones + shake de error (login/register/forgot) ── */
function chBtnLoading(btn, label) {
  if (!btn) return;
  btn.disabled = true;
  if (btn.dataset.origHtml == null) btn.dataset.origHtml = btn.innerHTML;
  btn.innerHTML = '<span class="sr-ch-btn-spinner"></span> ' + chEscape(label);
}
function chBtnReset(btn) {
  if (!btn) return;
  btn.disabled = false;
  if (btn.dataset.origHtml != null) { btn.innerHTML = btn.dataset.origHtml; delete btn.dataset.origHtml; }
}
function chShakeCard() {
  const card = document.querySelector('.sr-ch-form-card');
  if (!card) return;
  card.classList.remove('shake');
  void card.offsetWidth; // forzar reflow para poder re-disparar la animación
  card.classList.add('shake');
  setTimeout(() => card.classList.remove('shake'), 550);
}

function chNotif(msg, type = 'info', ms = 3500) {
  const wrap = document.getElementById('sr-ch-notif');
  if (!wrap) return;
  const el = document.createElement('div');
  el.className = 'sr-ch-notif-item' + (type !== 'info' ? ' ' + type : '');
  el.textContent = msg;
  wrap.appendChild(el);
  setTimeout(() => el.remove(), ms);
}

function chFormatDate(ts) {
  if (!ts) return '—';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('es-GT', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' });
}

function chTimeLeft(ts) {
  if (!ts) return { label: '—', status: 'ok' };
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  const diff = d - Date.now();
  if (diff <= 0) return { label: 'Cerrado', status: 'closed' };
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  if (h < 2) return { label: `${h}h ${m}m`, status: 'soon' };
  if (h < 24) return { label: `${h}h ${m}m`, status: 'ok' };
  const days = Math.floor(h / 24);
  return { label: `${days}d ${h % 24}h`, status: 'ok' };
}

// Un partido está cerrado para predicciones si: ya pasó su lockAt, YA está
// finalizado, O el admin lo marcó manualmente como "Cerrado" (status:'locked')
// desde el selector de estado del panel admin. Ese tercer caso existía en el
// selector del admin (statusOpts en _matchEditCard) desde hace tiempo pero
// nunca se revisaba acá — el admin podía marcar "Cerrado" y los usuarios
// seguían viendo el partido abierto hasta que venciera lockAt. Bug real,
// corregido centralizando el criterio en un solo lugar (antes duplicado
// inline en 6 sitios distintos).
function _chIsClosed(m) {
  return chTimeLeft(m.lockAt || m.deadline).status === 'closed' ||
    m.status === 'finished' || m.status === 'locked';
}

// `levels` es opcional (por defecto CH_DATA.termometro): así, cualquier pantalla
// que ya tenga los premios reales de Firestore (_prizesData) puede pasarlos para
// que el nivel mostrado nunca quede desincronizado si el admin edita los puntos
// de premio — antes SIEMPRE se usaba el valor por defecto hardcodeado, aunque el
// admin hubiera configurado otros puntos en la pantalla de Premios.
function chGetLevel(pts, levels) {
  const arr = levels || CH_DATA.termometro;
  let level = null;
  for (const t of arr) {
    if (pts >= t.pts) level = t;
  }
  return level;
}

function chGetNextLevel(pts, levels) {
  const arr = levels || CH_DATA.termometro;
  return arr.find(t => pts < t.pts) || null;
}

/* ══════════════════════════════════════════════════════
   CHAMPIONS APP
══════════════════════════════════════════════════════ */
const ChampionsApp = (() => {

  let _db, _auth, _user, _profile = {}, _config = {}, _premios = {}, _prizesData = [];
  let _sponsors = { title: null, banners: [] };
  let _productBanners = [];

  /* ── Caché corta de perfiles de todos los participantes ──
     Dashboard (chip de posición), Ranking y Mis Stats hacían, cada uno por su
     cuenta, un .get() de TODA la colección users + un ch_profile/main por
     usuario (N+1) — en una sesión donde el usuario va y viene entre esas 3
     pantallas (muy común), eso repetía el mismo escaneo completo una y otra
     vez. Con esta caché de 20s, cambiar de pestaña varias veces seguidas
     reusa los mismos datos en vez de re-escanear todo cada vez; los puntos
     no cambian tan seguido como para que 20s de posible desfase importen. */
  let _chProfilesCache = null;
  let _chProfilesCacheAt = 0;
  const CH_PROFILES_TTL_MS = 20000;

  async function _chGetAllProfiles(forceFresh) {
    const now = Date.now();
    if (!forceFresh && _chProfilesCache && (now - _chProfilesCacheAt) < CH_PROFILES_TTL_MS) {
      return _chProfilesCache;
    }
    const snap = await _db.collection('users').get();
    const rows = [];
    await Promise.all(snap.docs.map(doc =>
      _db.doc('users/' + doc.id + '/ch_profile/main').get().then(ps => {
        if (!ps.exists) return;
        const base = doc.data() || {};
        const prof = ps.data();
        rows.push({
          uid: doc.id,
          displayName: prof.displayName || base.displayName || '?',
          totalPoints: prof.totalPoints || 0,
          nivel: prof.nivel || 0,
          maxStreak: prof.maxStreak || 0,
          correctos: prof.correctos || 0
        });
      }).catch(() => {})
    ));
    _chProfilesCache = rows;
    _chProfilesCacheAt = now;
    return rows;
  }

  /* ── Init Firebase ─────────────────────────────────── */
  async function init() {
    // Mover el root directamente a <body> para escapar cualquier
    // CSS transform de Shopify que bloquea position:fixed
    const root = document.getElementById('sr-champions-root');
    if (root && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    await _waitSDK();
    // Evitar inicializar dos veces si la app ya existe
    const existing = firebase.apps.find(a => a.name === 'champions');
    const app = existing || firebase.initializeApp(CH_FIREBASE_CONFIG, 'champions');
    _auth = firebase.auth(app);
    _db   = firebase.firestore(app);

    _auth.onAuthStateChanged(async (user) => {
      try {
        if (user) {
          _user = user;
          // _loadProfile()/_loadConfig() ya no hace falta llamarlos acá — showScreen()
          // los refresca en cada navegación, incluida esta primera vez.
          _showPortal();
          showScreen('dashboard');
        } else {
          _user = null;
          _profile = {};
          _showLogin();
        }
      } catch(err) {
        console.error('[Champions] onAuthStateChanged error:', err.code, err.message);
        _showLogin();
        chNotif('Error al cargar tu perfil. Intentá de nuevo.', 'error');
      }
      _hideLoader();
    });
  }

  function _waitSDK() {
    return new Promise(res => {
      const check = () => (typeof firebase !== 'undefined' && firebase.firestore) ? res() : setTimeout(check, 50);
      check();
    });
  }

  function _hideLoader() { const l = document.getElementById('sr-ch-loader'); if (l) l.style.display = 'none'; }
  function _showLogin()  {
    document.getElementById('sr-ch-login').style.display = 'grid';
    document.getElementById('sr-ch-portal').style.display = 'none';
    // Defensivo: si un intento anterior (login/registro) dejó algún botón
    // trabado en estado "cargando" (p.ej. por un logout+login muy seguido),
    // esto asegura que la pantalla de login siempre arranque limpia.
    ['sr-ch-login-btn', 'sr-ch-reg-btn', 'sr-ch-forgot-btn'].forEach(id => chBtnReset(document.getElementById(id)));
  }
  function _showPortal() {
    document.getElementById('sr-ch-login').style.display  = 'none';
    document.getElementById('sr-ch-portal').style.display = 'block';
  }

  /* ── Auth ──────────────────────────────────────────── */
  async function login(e) {
    e.preventDefault();
    const userOrEmail = document.getElementById('sr-ch-login-user').value.trim();
    const pass  = document.getElementById('sr-ch-login-pass').value;
    const btn   = document.getElementById('sr-ch-login-btn');
    chBtnLoading(btn, 'Entrando...');
    try {
      if (!_auth) throw new Error('Firebase no inicializado. Recargá la página.');
      let email = userOrEmail.toLowerCase();
      if (!email.includes('@')) {
        const unameDoc = await _db.doc('usernames/' + email).get();
        if (!unameDoc.exists) {
          chNotif('No encontramos una cuenta con ese usuario', 'error');
          chBtnReset(btn);
          chShakeCard();
          return;
        }
        email = unameDoc.data().email;
      }
      const cred = await _auth.signInWithEmailAndPassword(email, pass);
      // No dependemos únicamente de onAuthStateChanged para pasar al portal —
      // en algunos casos (p.ej. login inmediatamente después de un logout) el
      // evento puede demorar o no disparar a tiempo, dejando el botón
      // "Entrando..." trabado para siempre. Disparamos la transición acá mismo.
      _user = cred.user;
      _showPortal();
      showScreen('dashboard');
    } catch(err) {
      console.error('[Champions] Login error:', err.code, err.message);
      let msg = 'Error al conectar. Recargá la página e intentá de nuevo.';
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        msg = 'Usuario/correo o contraseña incorrectos';
      } else if (err.code === 'auth/too-many-requests') {
        msg = 'Demasiados intentos fallidos. Esperá unos minutos.';
      } else if (err.code === 'auth/invalid-email') {
        msg = 'Formato de correo inválido';
      } else if (err.code === 'auth/network-request-failed') {
        msg = 'Sin conexión a internet. Verificá tu red.';
      }
      chNotif(msg, 'error');
      chBtnReset(btn);
      chShakeCard();
    }
  }

  async function register(e) {
    e.preventDefault();
    const name     = document.getElementById('sr-ch-reg-name').value.trim();
    const username = document.getElementById('sr-ch-reg-username').value.trim();
    const email    = document.getElementById('sr-ch-reg-email').value.trim();
    const pass     = document.getElementById('sr-ch-reg-pass').value;
    const club     = document.getElementById('sr-ch-reg-club').value;
    const btn      = document.getElementById('sr-ch-reg-btn');

    if (username.length < 4) {
      chNotif('El usuario debe tener al menos 4 caracteres', 'error');
      return chShakeCard();
    }
    if (!/^[a-zA-Z0-9_.-]+$/.test(username)) {
      chNotif('El usuario solo puede tener letras, números, puntos, guiones y _ (no uses tu correo)', 'error');
      return chShakeCard();
    }
    const acceptTerms = document.getElementById('sr-ch-reg-terms');
    if (!acceptTerms || !acceptTerms.checked) {
      chNotif('Debés leer y aceptar cómo funciona la quiniela y los Términos y Condiciones', 'error');
      return chShakeCard();
    }

    chBtnLoading(btn, 'Creando...');
    try {
      if (!_auth) throw new Error('Firebase no inicializado');
      const usernameLower = username.toLowerCase();
      // Chequeo de unicidad "best effort": si falla por reglas de Firestore aún
      // no configuradas (o por red), no bloqueamos el registro completo por esto —
      // solo avisamos en consola y seguimos. El riesgo de un choque de username
      // es mucho menor que dejar a todos sin poder crear cuenta.
      try {
        const unameDoc = await _db.doc('usernames/' + usernameLower).get();
        if (unameDoc.exists) {
          chNotif('Ese nombre de usuario ya está en uso', 'error');
          chBtnReset(btn);
          chShakeCard();
          return;
        }
      } catch(uErr) {
        console.warn('[Champions] Username uniqueness check failed (rules?):', uErr.code, uErr.message);
      }

      const cred = await _auth.createUserWithEmailAndPassword(email, pass);
      const now  = firebase.firestore.FieldValue.serverTimestamp();
      // Intentar escribir perfil — si falla por reglas, la cuenta auth sí queda creada
      try {
        await _db.doc('users/' + cred.user.uid).set({
          displayName: name, username, usernameLower, favoriteClub: club,
          email: cred.user.email, createdAt: now
        }, { merge: true });
        await _db.doc('users/' + cred.user.uid + '/ch_profile/main').set({
          displayName: name, totalPoints: 0, streak: 0, maxStreak: 0,
          correctos: 0, exactos: 0, anotadores: 0,
          nivel: 0, medals: [], finalPredicted: false, fullJornada: false,
          createdAt: now
        }, { merge: true });
        await _db.doc('usernames/' + usernameLower).set({ uid: cred.user.uid, email: cred.user.email });
      } catch(dbErr) {
        console.warn('[Champions] Profile write failed (rules?):', dbErr.code, dbErr.message);
      }
      chNotif('¡Bienvenido ' + name + '! Accediendo...', 'success');
      // Mismo motivo que en login(): no depender solo de onAuthStateChanged para
      // no dejar la pantalla trabada si el evento se demora.
      _user = cred.user;
      _showPortal();
      showScreen('dashboard');
    } catch(err) {
      console.error('[Champions] Register error:', err.code, err.message);
      let msg = 'Error al registrar. Intentá de nuevo.';
      if (err.code === 'auth/email-already-in-use') msg = 'Ese correo ya tiene una cuenta. Iniciá sesión.';
      else if (err.code === 'auth/weak-password') msg = 'La contraseña es muy débil (mínimo 6 caracteres).';
      else if (err.code === 'auth/invalid-email') msg = 'Formato de correo inválido.';
      chNotif(msg, 'error');
      chBtnReset(btn);
      chShakeCard();
    }
  }

  async function logout() {
    await _auth.signOut();
    // Igual que en login/register: no depender solo de onAuthStateChanged
    // para volver a la pantalla de login.
    _user = null;
    _profile = {};
    _showLogin();
    chNotif('Sesión cerrada');
  }

  function showForgot() { toggleForm('forgot'); }

  async function sendReset(e) {
    e.preventDefault();
    const email = document.getElementById('sr-ch-forgot-email').value.trim();
    const btn   = document.getElementById('sr-ch-forgot-btn');
    chBtnLoading(btn, 'Enviando...');
    try {
      await _auth.sendPasswordResetEmail(email);
      chNotif('Enlace enviado a ' + email, 'success');
      toggleForm('signin');
    } catch(err) {
      chNotif('No se encontró ese correo', 'error');
      chShakeCard();
    } finally {
      chBtnReset(btn);
    }
  }

  /* ── Modal "Cómo funciona + Términos" (registro, previo al login) ── */
  function showHowItWorksModal() {
    const overlay = document.getElementById('sr-ch-how-modal-overlay');
    const body = document.getElementById('sr-ch-how-modal-body');
    if (!overlay || !body) return;
    body.innerHTML = _howItWorksContent();
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeHowItWorksModal() {
    const overlay = document.getElementById('sr-ch-how-modal-overlay');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function _howItWorksContent() {
    let ptsRows = '';
    CH_DATA.fases.forEach(f => {
      ptsRows += '<tr><td>' + chEscape(f.nombre) + '</td><td>' + f.puntos.resultado + ' pts</td><td>' + f.puntos.exacto + ' pts</td><td>' + f.puntos.anotador + ' pts</td></tr>';
    });
    let rachaRows = '';
    CH_DATA.rachas.forEach(r => {
      rachaRows += r.n + ' aciertos seguidos: <strong>+' + r.bonus + ' pts</strong> &nbsp;·&nbsp; ';
    });
    rachaRows = rachaRows.replace(/ &nbsp;·&nbsp; $/, '');

    return (
      '<h3>¿Qué es la Quiniela Champions?</h3>' +
      '<p>Es un concurso de predicciones <strong>100% gratuito</strong> organizado por Soccer Revolution. No es una apuesta: no pagás ni arriesgás dinero para participar. Ganás puntos por adivinar resultados, no apostando contra otros usuarios.</p>' +

      '<h3>1. Registrate</h3>' +
      '<p>Una cuenta por persona. Pedimos nombre completo, usuario, correo, contraseña y equipo favorito (opcional). Tu correo <strong>nunca</strong> se muestra públicamente — en el ranking solo aparece tu usuario.</p>' +

      '<h3>2. Predecí antes de que cierre cada partido</h3>' +
      '<p><strong>Fase de Liga:</strong> ingresá el marcador que creés que va a quedar en cada uno de los partidos de las 8 jornadas.</p>' +
      '<p><strong>Eliminatorias (ida y vuelta):</strong> predecís el marcador de cada partido por separado, más quién creés que <strong>clasifica</strong> a la siguiente ronda — esto se elige aparte, directamente, no se calcula a partir de tus marcadores.</p>' +
      '<p>Cada partido tiene una hora de cierre (el inicio del partido). Después de esa hora <strong>ya no podés cambiar tu predicción</strong>. Si no predijiste a tiempo, no ganás puntos en ese partido y se corta tu racha de aciertos.</p>' +

      '<h3>3. Sistema de puntos</h3>' +
      '<div class="sr-ch-pts-table-wrap"><table class="sr-ch-pts-table">' +
        '<thead><tr><th>Fase</th><th>Resultado</th><th>Exacto</th><th>Anotador</th></tr></thead>' +
        '<tbody>' + ptsRows + '</tbody>' +
      '</table></div>' +
      '<ul>' +
        '<li><strong>Resultado correcto:</strong> adivinaste quién gana (o que es empate), sin importar el marcador exacto.</li>' +
        '<li><strong>Marcador exacto:</strong> adivinaste el marcador exacto — se suma a los puntos de "resultado correcto".</li>' +
        '<li><strong>Anotador:</strong> es el <strong>equipo</strong> que mete el primer gol del partido, no un jugador en particular — elegís local, visitante, o "sin goles".</li>' +
      '</ul>' +
      '<div class="sr-ch-bonus-info"><strong>🔥 BONUS RACHA:</strong> ' + rachaRows + '. La racha se corta si fallás un partido o no enviaste tu predicción a tiempo.</div>' +

      '<h3>4. ⚠️ ¿Y si un partido de eliminatorias se define por penales?</h3>' +
      '<p>Desde los octavos de final, si un partido termina empatado en el global se puede definir por tiempo extra y penales. <strong>No necesitás predecir nada de eso</strong>: vos elegís directamente quién clasifica a la siguiente ronda, en un campo aparte de los marcadores. Tu predicción de marcador se califica igual, sin importar cómo se haya resuelto la clasificación.</p>' +

      '<h3>5. Ranking</h3>' +
      '<p>Se ordena por puntos totales. En caso de empate en puntos, desempata primero quien tenga más aciertos y, si sigue habiendo empate, el orden alfabético del usuario.</p>' +

      '<h3>6. Premios</h3>' +
      '<p>Soccer Revolution premia distintos niveles de puntos acumulados durante la temporada — los detalles y valores vigentes están en la pestaña "Premios" dentro de la app y pueden actualizarse durante la temporada. La entrega está sujeta a verificar la identidad del ganador y a poder contactarlo con los datos proporcionados al registrarse.</p>' +

      '<h3>7. Resultados y correcciones</h3>' +
      '<p>Los resultados los ingresa el equipo de Soccer Revolution después de cada partido oficial. Si se detecta un error en un resultado ya cargado, se corrige y los puntos de todos los participantes se recalculan automáticamente. La decisión del equipo de Soccer Revolution sobre el resultado oficial de un partido es definitiva.</p>' +

      '<h3>8. Tus datos</h3>' +
      '<p>Pedimos nombre, usuario, correo, contraseña y equipo favorito (opcional) únicamente para identificarte dentro de la quiniela y poder contactarte si ganás un premio. Tu correo electrónico nunca se comparte ni se muestra públicamente.</p>' +

      '<h3>9. Conducta</h3>' +
      '<p>No se permite crear varias cuentas para acumular más oportunidades de premio, ni usar nombres de usuario ofensivos o que sean direcciones de correo. Soccer Revolution puede suspender cuentas que incumplan estas reglas.</p>' +

      '<p class="sr-ch-how-modal-footer">Al marcar la casilla de aceptación en el registro, confirmás que leíste y entendiste todo lo anterior.</p>'
    );
  }

  function toggleForm(which) {
    ['signin','register','forgot'].forEach(f => {
      document.getElementById('sr-ch-form-' + f).style.display = f === which ? 'block' : 'none';
    });
    // El registro tiene bastantes más campos que el login: en móvil se activa un
    // modo compacto solo para esa pantalla (ver CSS), para no apretar el login.
    const loginRoot = document.getElementById('sr-ch-login');
    if (loginRoot) loginRoot.classList.toggle('sr-ch-is-register', which === 'register');
    // Foco automático en el primer campo del formulario recién mostrado — el usuario
    // ya interactuó (tocó un link) así que abrir el teclado en móvil aquí es bienvenido.
    const firstInput = document.querySelector('#sr-ch-form-' + which + ' input');
    if (firstInput) setTimeout(() => firstInput.focus(), 60);
  }

  function togglePasswordVisibility(inputId, btn) {
    const input = document.getElementById(inputId);
    if (!input) return;
    const showing = input.type === 'password';
    input.type = showing ? 'text' : 'password';
    if (btn) {
      btn.textContent = showing ? '🙈' : '👁';
      btn.setAttribute('aria-label', showing ? 'Ocultar contraseña' : 'Mostrar contraseña');
    }
  }

  /* ── Load data ─────────────────────────────────────── */
  async function _loadProfile() {
    if (!_user) return;
    const snap = await _db.doc('users/' + _user.uid + '/ch_profile/main').get();
    _profile = snap.exists ? snap.data() : {};
    _profile.totalPoints = _profile.totalPoints || 0;
  }

  async function _loadConfig() {
    const snap = await _db.doc('config/main').get();
    _config = snap.exists ? snap.data() : {};
    const pSnap = await _db.doc('premios/main').get();
    _premios = pSnap.exists ? pSnap.data() : {};
    try {
      const prSnap = await _db.doc('config/prizes').get();
      if (prSnap.exists && Array.isArray(prSnap.data().levels)) {
        _prizesData = prSnap.data().levels.slice().sort((a, b) => (a.pts || 0) - (b.pts || 0));
      } else {
        _prizesData = [];
      }
    } catch(_) {
      _prizesData = [];
    }
    try {
      const ptsSnap = await _db.doc('config/points').get();
      _applyPointsConfig(ptsSnap.exists ? ptsSnap.data() : null);
    } catch(_) { /* si falla, seguir con los valores por defecto ya cargados */ }
    try {
      const spSnap = await _db.collection('champions_sponsors').get();
      const all = [];
      spSnap.forEach(d => all.push({ id: d.id, ...d.data() }));
      _sponsors.title = all.find(s => s.tier === 'title' && s.active !== false) || null;
      _sponsors.banners = all.filter(s => s.tier === 'banner' && s.active !== false)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    } catch(_) {
      _sponsors = { title: null, banners: [] };
    }
    try {
      const bnSnap = await _db.collection('champions_banners').get();
      const all = [];
      bnSnap.forEach(d => all.push({ id: d.id, ...d.data() }));
      _productBanners = all.filter(_isBannerLive).sort((a, b) => (a.order || 0) - (b.order || 0));
    } catch(_) {
      _productBanners = [];
    }
  }

  // Mismo criterio "en vivo" que CHAdmin._isBannerLive en sr-champions-admin.js
  // (activo + dentro del rango de fechas programado, si tiene) — se mantiene en
  // ambos lados porque son dos bundles JS separados sin estado compartido.
  function _isBannerLive(b) {
    if (b.active === false) return false;
    const now = Date.now();
    if (b.startAt && new Date(b.startAt).getTime() > now) return false;
    if (b.endAt && new Date(b.endAt).getTime() < now) return false;
    return true;
  }

  // Niveles activos del termómetro, normalizados a la forma de CH_DATA.termometro
  // ({pts,nivel,label,icon}) — usa los premios reales de Firestore (_prizesData)
  // si el admin ya los configuró, para que chGetLevel()/chGetNextLevel() nunca
  // muestren un nivel desincronizado del que se ve en la pantalla de Premios.
  function _chActiveLevels() {
    if (_prizesData.length > 0) {
      return _prizesData.slice().sort((a, b) => (a.pts || 0) - (b.pts || 0))
        .map((p, i) => ({ pts: p.pts, nivel: i + 1, label: p.title || '', icon: p.icon || '🏆' }));
    }
    return CH_DATA.termometro;
  }

  // Muta en sitio CH_DATA.fases[].puntos, CH_DATA.rachas y CH_PHASE_PTS_BY_KEY
  // (que PHASE_PTS en _renderMisStats referencia como alias) — así todas las
  // funciones que ya leen esos objetos compartidos reciben la config
  // personalizada del admin sin que haya que tocarlas una por una.
  function _applyPointsConfig(points) {
    if (!points) return;
    const keyByFaseId = { liga:'league', playoff:'playoff', octavos:'r16', cuartos:'qf', semifinal:'sf', final:'final' };
    CH_DATA.fases.forEach(fase => {
      const key = keyByFaseId[fase.id];
      if (key && points[key]) Object.assign(fase.puntos, points[key]);
    });
    Object.keys(CH_PHASE_PTS_BY_KEY).forEach(key => {
      if (points[key]) Object.assign(CH_PHASE_PTS_BY_KEY[key], points[key]);
    });
    if (Array.isArray(points.racha) && points.racha.length) {
      CH_DATA.rachas.length = 0;
      points.racha.forEach(r => CH_DATA.rachas.push(r));
    }
  }

  /* ── Carrusel de Banners de producto (Dashboard) ──────
     Promociones de Soccer Revolution, no patrocinadores — el admin las sube y
     puede programarlas por fecha desde la pestaña Banners. _productBanners ya
     viene filtrado a "en vivo" y ordenado desde _loadConfig(). ──── */

  function renderBannerCarousel() {
    const el = document.getElementById('sr-ch-banner-carousel');
    if (!el) return;
    clearInterval(el._bannerRotateTimer);

    const banners = _productBanners || [];
    el.style.display = '';

    // Sin banners reales cargados todavía: mostrar un espacio de ejemplo (no
    // ocultar) para poder enseñarle a una marca, en el producto real, cómo se
    // ve un banner de carrusel completo. Mismo espíritu que el placeholder de
    // Sponsors — desaparece solo apenas el admin carga un banner de verdad.
    if (banners.length === 0) {
      el.classList.add('sr-ch-banner-preview');
      el.innerHTML =
        '<div class="sr-ch-banner-track">' +
          '<div class="sr-ch-banner-slide sr-ch-banner-slide-placeholder">' +
            '<div class="sr-ch-banner-overlay">' +
              '<div class="sr-ch-banner-title sr-ch-sponsor-placeholder-text">TU BANNER AQUÍ</div>' +
              '<span class="sr-ch-banner-cta sr-ch-banner-cta-placeholder sr-ch-sponsor-placeholder-text">Espacio disponible</span>' +
            '</div>' +
          '</div>' +
        '</div>';
      return;
    }
    el.classList.remove('sr-ch-banner-preview');

    const slide = (b, i) => {
      const overlay = (b.title || b.ctaText)
        ? '<div class="sr-ch-banner-overlay">' +
            (b.title ? '<div class="sr-ch-banner-title">' + chEscape(b.title) + '</div>' : '') +
            (b.ctaText ? '<span class="sr-ch-banner-cta">' + chEscape(b.ctaText) + '</span>' : '') +
          '</div>'
        : '';
      const inner = '<img class="sr-ch-banner-img" src="' + chEscape(b.image) + '" alt="' + chEscape(b.title || 'Banner') + '" draggable="false">' + overlay;
      return b.link
        ? '<a class="sr-ch-banner-slide" href="' + chEscape(b.link) + '" data-idx="' + i + '" onclick="ChampionsApp.bannerClick(\'' + b.id + '\')">' + inner + '</a>'
        : '<div class="sr-ch-banner-slide" data-idx="' + i + '">' + inner + '</div>';
    };

    const dots = banners.length > 1
      ? '<div class="sr-ch-banner-dots">' +
          banners.map((_, i) => '<button type="button" class="sr-ch-banner-dot' + (i === 0 ? ' active' : '') + '" onclick="ChampionsApp._bannerGoTo(' + i + ')" aria-label="Banner ' + (i + 1) + '"></button>').join('') +
        '</div>'
      : '';

    el.innerHTML =
      '<div class="sr-ch-banner-track" style="transform:translateX(0%)">' + banners.map(slide).join('') + '</div>' +
      dots;

    if (banners.length <= 1) return; // 1 solo banner: estático, sin dots ni autoplay

    const track = el.querySelector('.sr-ch-banner-track');
    let current = 0;

    const goTo = idx => {
      current = ((idx % banners.length) + banners.length) % banners.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      el.querySelectorAll('.sr-ch-banner-dot').forEach((d, i) => d.classList.toggle('active', i === current));
    };
    el._bannerGoTo = goTo;

    const restartAutoplay = () => {
      clearInterval(el._bannerRotateTimer);
      el._bannerRotateTimer = setInterval(() => goTo(current + 1), 5000);
    };
    restartAutoplay();
    el.addEventListener('mouseenter', () => clearInterval(el._bannerRotateTimer));
    el.addEventListener('mouseleave', restartAutoplay);

    // Swipe táctil a mano (sin librería) — umbral de distancia simple, sin
    // física de inercia. Mismo espíritu "vanilla" que el resto del proyecto.
    let startX = 0, deltaX = 0, dragging = false;
    el.addEventListener('pointerdown', e => {
      dragging = true; startX = e.clientX; deltaX = 0;
      clearInterval(el._bannerRotateTimer);
      track.style.transition = 'none';
    });
    el.addEventListener('pointermove', e => {
      if (!dragging) return;
      deltaX = e.clientX - startX;
      const pct = (deltaX / el.offsetWidth) * 100;
      track.style.transform = 'translateX(calc(-' + (current * 100) + '% + ' + pct + '%))';
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(deltaX) > el.offsetWidth * 0.18) {
        goTo(current + (deltaX < 0 ? 1 : -1));
      } else {
        goTo(current);
      }
      restartAutoplay();
    };
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', () => { if (dragging) endDrag(); });
  }

  // Registra un clic real en un banner (para que el admin vea cuáles
  // productos generan más interés) — no bloquea la navegación al link.
  function bannerClick(id) {
    _db.doc('champions_banners/' + id).update({
      clicks: firebase.firestore.FieldValue.increment(1)
    }).catch(() => {});
  }

  // Wrapper expuesto para los onclick de los dots — delega al goTo guardado
  // en el elemento por renderBannerCarousel(). El carrusel solo vive en el
  // Dashboard, así que hay un único mount point (a diferencia del banner
  // rotativo de sponsors, que se repite en varias pantallas).
  function _bannerGoTo(idx) {
    const el = document.getElementById('sr-ch-banner-carousel');
    if (el && el._bannerGoTo) el._bannerGoTo(idx);
  }

  /* ── Patrocinadores (Título + Banner rotativo) ────────
     Título: banner destacado, máxima visibilidad — solo en el Dashboard.
     Banner rotativo: franja de logos en Dashboard/Ranking/Premios/Mis Stats/Medallas.
     Ambos se cargan una vez por navegación en _loadConfig() (_sponsors). ──── */

  function renderSponsorTitle() {
    const el = document.getElementById('sr-ch-sponsor-title');
    if (!el) return;
    const s = _sponsors.title;
    el.style.display = '';
    // Sin sponsor real cargado todavía: mostrar un espacio de ejemplo (no ocultar)
    // para poder enseñarle a una marca, en el producto real, dónde va a quedar su
    // logo. Desaparece solo apenas el admin carga un Patrocinador Oficial de verdad.
    if (!s) {
      el.classList.add('sr-ch-sponsor-preview');
      el.innerHTML =
        '<span class="sr-ch-sponsor-title-label">PRESENTADO POR</span>' +
        '<span class="sr-ch-sponsor-title-name sr-ch-sponsor-placeholder-text">PATROCINADOR</span>';
      return;
    }
    el.classList.remove('sr-ch-sponsor-preview');
    const inner =
      '<span class="sr-ch-sponsor-title-label">PRESENTADO POR</span>' +
      (s.logo
        ? '<img class="sr-ch-sponsor-title-logo" src="' + chEscape(s.logo) + '" alt="' + chEscape(s.name) + '">'
        : '<span class="sr-ch-sponsor-title-name">' + chEscape(s.name) + '</span>');
    el.innerHTML = s.url
      ? '<a href="' + chEscape(s.url) + '" target="_blank" rel="noopener" onclick="ChampionsApp.sponsorClick(\'' + s.id + '\')">' + inner + '</a>'
      : inner;
  }

  function renderSponsorStrip() {
    // Varias pantallas coexisten en el DOM a la vez (solo se ocultan con CSS) — un
    // id compartido haría que getElementById siempre devolviera la primera pantalla
    // sin importar cuál está realmente visible, así que cada mount point usa una
    // clase y se actualizan todos (los ocultos no cuestan nada visible).
    document.querySelectorAll('.sr-ch-sponsor-strip-mount').forEach(_renderSponsorStripInto);
  }

  function _renderSponsorStripInto(el) {
    // El timer va EN el propio elemento, no en una variable compartida — con
    // varios mount points a la vez, un solo timer compartido dejaría animado
    // solo al último procesado.
    clearInterval(el._sponsorRotateTimer);
    const banners = _sponsors.banners || [];
    el.style.display = '';
    // Igual que renderSponsorTitle(): sin sponsors reales todavía, mostrar 3
    // espacios de ejemplo en vez de ocultar la franja — así se puede mostrar en
    // el sitio real dónde van a quedar los logos rotativos.
    if (banners.length === 0) {
      el.classList.add('sr-ch-sponsor-preview');
      el.innerHTML = '<div class="sr-ch-sponsor-page active">' +
        '<div class="sr-ch-sponsor-item"><span class="sr-ch-sponsor-item-name sr-ch-sponsor-placeholder-text">PATROCINADOR</span></div>' +
        '<div class="sr-ch-sponsor-item"><span class="sr-ch-sponsor-item-name sr-ch-sponsor-placeholder-text">PATROCINADOR</span></div>' +
        '<div class="sr-ch-sponsor-item"><span class="sr-ch-sponsor-item-name sr-ch-sponsor-placeholder-text">PATROCINADOR</span></div>' +
      '</div>';
      return;
    }
    el.classList.remove('sr-ch-sponsor-preview');

    const item = s => {
      const inner = s.logo
        ? '<img class="sr-ch-sponsor-item-logo" src="' + chEscape(s.logo) + '" alt="' + chEscape(s.name) + '">'
        : '<span class="sr-ch-sponsor-item-name">' + chEscape(s.name) + '</span>';
      return '<div class="sr-ch-sponsor-item">' +
        (s.url
          ? '<a href="' + chEscape(s.url) + '" target="_blank" rel="noopener" onclick="ChampionsApp.sponsorClick(\'' + s.id + '\')">' + inner + '</a>'
          : inner) +
      '</div>';
    };

    if (banners.length <= 3) {
      el.innerHTML = '<div class="sr-ch-sponsor-page active">' + banners.map(item).join('') + '</div>';
      return;
    }
    const pages = [];
    for (let i = 0; i < banners.length; i += 3) pages.push(banners.slice(i, i + 3));
    el.innerHTML = pages.map((page, i) =>
      '<div class="sr-ch-sponsor-page' + (i === 0 ? ' active' : '') + '">' + page.map(item).join('') + '</div>'
    ).join('');

    let current = 0;
    const startRotate = () => {
      clearInterval(el._sponsorRotateTimer);
      el._sponsorRotateTimer = setInterval(() => {
        const pageEls = el.querySelectorAll('.sr-ch-sponsor-page');
        if (pageEls.length < 2) return;
        pageEls[current].classList.remove('active');
        current = (current + 1) % pageEls.length;
        pageEls[current].classList.add('active');
      }, 4000);
    };
    startRotate();
    // Antes esto tenía { once: true } y nunca reanudaba la rotación después del
    // primer hover — quedaba pausada para siempre. Ahora pausa/reanuda como el
    // carrusel de banners.
    el.addEventListener('mouseenter', () => clearInterval(el._sponsorRotateTimer));
    el.addEventListener('mouseleave', startRotate);
  }

  // Registra un clic real en un sponsor para que el admin tenga un dato de
  // exposición real al negociar con marcas. Sin tracking de impresiones (escribir
  // en cada carga de pantalla saldría caro con muchos usuarios activos) — solo
  // clics reales. `id` es para Título/Banner (champions_sponsors/{id}); `prizeId`
  // es para el sponsor de un premio (embebido en el array config/prizes.levels[],
  // requiere leer-mutar-escribir todo el array, igual que _savePrizeLevels en el admin).
  function sponsorClick(id, prizeId) {
    if (id) {
      _db.doc('champions_sponsors/' + id).update({
        clicks: firebase.firestore.FieldValue.increment(1)
      }).catch(() => {});
      return;
    }
    if (prizeId) {
      _db.doc('config/prizes').get().then(snap => {
        if (!snap.exists) return;
        const levels = snap.data().levels || [];
        const idx = levels.findIndex(p => p.id === prizeId);
        if (idx === -1) return null;
        levels[idx] = Object.assign({}, levels[idx], { clicks: (levels[idx].clicks || 0) + 1 });
        return _db.doc('config/prizes').set({ levels }, { merge: true });
      }).catch(() => {});
    }
  }

  /* ── Screens ───────────────────────────────────────── */
  // Token de navegación: si el usuario toca dos veces seguidas (doble-tap en
  // "Inicio" es el caso más común, sobre todo en celular), antes se disparaban
  // dos showScreen() superpuestos que esperaban lo mismo y terminaban
  // corriendo _renderDashboard()/_loadDashRank() dos veces en paralelo,
  // escribiendo ambos sobre el mismo DOM sin orden garantizado. Con este
  // token, si empieza una navegación más nueva mientras la anterior todavía
  // esperaba el perfil/config, la vieja se cancela sin renderizar nada.
  let _chNavToken = 0;
  async function showScreen(name, opts) {
    const _myNavToken = ++_chNavToken;
    document.querySelectorAll('.sr-ch-screen').forEach(s => s.classList.remove('active'));
    const scr = document.getElementById('sr-ch-screen-' + name);
    if (scr) scr.classList.add('active');
    // Update desktop nav
    document.querySelectorAll('.sr-ch-nav-btn').forEach(b => b.classList.remove('active'));
    const activeNav = document.querySelector('.sr-ch-nav-btn[onclick*="\'' + name + '\'"]');
    if (activeNav) activeNav.classList.add('active');
    // Update bottom nav
    document.querySelectorAll('.sr-ch-bottom-btn').forEach(b => b.classList.remove('active'));
    const activeBottom = document.querySelector('.sr-ch-bottom-btn[onclick*="\'' + name + '\'"]');
    if (activeBottom) activeBottom.classList.add('active');

    // Refrescar perfil (puntos/nivel/racha) y config (jornadas/fases activas, premios)
    // en CADA navegación — antes solo se cargaban una vez al iniciar sesión, así que si
    // el admin recalculaba puntos o activaba una jornada/fase nueva mientras el usuario
    // ya estaba adentro, no se enteraba hasta cerrar sesión y volver a entrar. Mismo bug
    // ya corregido antes en la Quiniela Mundial (ver memoria del proyecto).
    if (_user) {
      try { await Promise.all([_loadProfile(), _loadConfig()]); } catch(e) { /* si falla, seguir con lo que ya había en memoria */ }
    }
    // Si mientras esperábamos arriba se disparó una navegación más nueva
    // (doble-tap, o el usuario cambió de pestaña antes de que esto resolviera),
    // esta pasada quedó obsoleta: no renderizar para no pisar/duplicar la nueva.
    if (_myNavToken !== _chNavToken) return;

    // Render per screen — opts permite saltar directo a una jornada/fase puntual
    // (ej. desde "Próximos Cierres" en el Dashboard) sin pisarse con la auto-selección.
    if (name === 'dashboard')       _renderDashboard();
    if (name === 'liga')            _renderLiga(opts && opts.jornada);
    if (name === 'eliminatorias')   _renderEliminatorias(opts && opts.fase);
    if (name === 'ranking')         _renderRanking();
    if (name === 'premios')         _renderPremios();
    if (name === 'como-funciona')   _renderComoFunciona();
    if (name === 'mis-stats')       _renderMisStats();
    if (name === 'medallas')        _renderMedallas();
    if (name === 'fama')            _renderFama();
    setTimeout(() => { chInitRipples(); chInitTilt(); }, 120);
  }

  /* ── Dashboard ─────────────────────────────────────── */
  function _renderDashboard() {
    const pts  = _profile.totalPoints || 0;
    const name = _profile.displayName || (_user && _user.email ? _user.email.split('@')[0] : '?');
    const init = name.charAt(0).toUpperCase();

    document.getElementById('sr-ch-dash-avatar').textContent = init;
    document.getElementById('sr-ch-dash-name').textContent   = name.toUpperCase();

    const greetEl = document.getElementById('sr-ch-dash-greeting');
    if (greetEl) greetEl.textContent = _chGreeting();

    const lvl   = chGetLevel(pts, _chActiveLevels());
    const lvlEl = document.getElementById('sr-ch-dash-level');
    if (lvlEl) lvlEl.textContent = lvl ? lvl.icon + ' ' + lvl.label : '⚽ Empezá a ganar puntos';

    const ptsNumEl = document.getElementById('sr-ch-dash-pts-num');
    if (ptsNumEl) chCountUp(ptsNumEl, pts, 900);

    _chInitSound();
    _checkPointsCelebration(pts);
    _renderThermo(pts);
    _updateHeader(pts, name, lvl);
    _renderAnnouncement();
    _renderNudge();
    _renderSeasonCountdown();
    _loadProximos();
    _loadDashRank();
    renderBannerCarousel();
    renderSponsorTitle();
    renderSponsorStrip();
    setTimeout(() => { chInitTilt(); chInitRipples(); }, 80);
  }

  /* ── Cuenta regresiva de arranque de temporada ──
     Mientras el admin no active ninguna jornada todavía (config.jornadasActivas
     vacío), pero ya existan los partidos reales de la Jornada 1 cargados
     (con su fecha de cierre real), mostramos un contador grande hacia ese
     kickoff en vez de dejar el Dashboard sin nada que anticipar. Se oculta
     solo cuando el admin activa la primera jornada. */
  let _seasonCdInterval = null;
  async function _renderSeasonCountdown() {
    const el = document.getElementById('sr-ch-season-countdown');
    if (!el) return;
    if (_seasonCdInterval) { clearInterval(_seasonCdInterval); _seasonCdInterval = null; }

    const activeJ = _config.jornadasActivas || [];
    if (activeJ.length > 0) { el.style.display = 'none'; el.innerHTML = ''; return; }

    try {
      const snap = await _db.collection('matches').where('phase', '==', 'league').where('matchday', '==', 1).get();
      const docs = [];
      snap.forEach(d => { if (d.id !== 'test_match') docs.push(d.data()); });
      if (docs.length === 0) { el.style.display = 'none'; el.innerHTML = ''; return; }

      let minLock = null;
      docs.forEach(m => {
        if (!m.lockAt) return;
        const d = new Date(m.lockAt);
        if (!minLock || d < minLock) minLock = d;
      });
      if (!minLock || minLock <= new Date()) { el.style.display = 'none'; el.innerHTML = ''; return; }

      const totalMatches = docs.length * 8; // 18 x 8 jornadas = 144

      el.style.display = 'block';
      el.innerHTML =
        '<div class="sr-ch-season-cd">' +
          '<div class="sr-ch-season-cd__badge">🏆 TEMPORADA 26/27</div>' +
          '<div class="sr-ch-season-cd__title">La Champions arranca en</div>' +
          '<div class="sr-ch-season-cd__timer">' +
            '<div class="sr-ch-season-cd__unit"><span id="sr-ch-scd-d">--</span><small>DÍAS</small></div>' +
            '<div class="sr-ch-season-cd__unit"><span id="sr-ch-scd-h">--</span><small>HRS</small></div>' +
            '<div class="sr-ch-season-cd__unit"><span id="sr-ch-scd-m">--</span><small>MIN</small></div>' +
          '</div>' +
          '<div class="sr-ch-season-cd__stats">' +
            '<span>⚽ ' + totalMatches + ' partidos</span>' +
            '<span>🌍 36 equipos</span>' +
            '<span>📅 8 jornadas</span>' +
          '</div>' +
        '</div>';

      const tick = () => {
        const diff = minLock - new Date();
        if (diff <= 0) { clearInterval(_seasonCdInterval); _seasonCdInterval = null; _renderSeasonCountdown(); return; }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const set = (id, v) => { const e = document.getElementById(id); if (e) e.textContent = String(v).padStart(2, '0'); };
        set('sr-ch-scd-d', d); set('sr-ch-scd-h', h); set('sr-ch-scd-m', m);
      };
      tick();
      _seasonCdInterval = setInterval(tick, 60000);
    } catch (e) {
      el.style.display = 'none';
      el.innerHTML = '';
    }
  }

  function _chGreeting() {
    const h = new Date().getHours();
    if (h < 6)  return '🌙 Buenas noches';
    if (h < 12) return '☀️ Buenos días';
    if (h < 19) return '🌤 Buenas tardes';
    return '🌙 Buenas noches';
  }

  /* ── Sonido (opt-in, apagado por defecto — igual que la Quiniela Mundial) ── */
  let _chSoundEnabled = false;
  let _chAudioCtx = null;

  function _chInitSound() {
    _chSoundEnabled = localStorage.getItem('sr-ch-sound') === '1';
    const btn = document.getElementById('sr-ch-sound-btn');
    if (btn) {
      btn.textContent = _chSoundEnabled ? '🔊' : '🔇';
      btn.classList.toggle('on', _chSoundEnabled);
    }
  }

  function toggleSound() {
    _chSoundEnabled = !_chSoundEnabled;
    localStorage.setItem('sr-ch-sound', _chSoundEnabled ? '1' : '0');
    const btn = document.getElementById('sr-ch-sound-btn');
    if (btn) {
      btn.textContent = _chSoundEnabled ? '🔊' : '🔇';
      btn.classList.toggle('on', _chSoundEnabled);
    }
    chNotif(_chSoundEnabled ? '🔊 Sonidos activados' : '🔇 Sonidos desactivados', 'info');
  }

  /* ── Anuncio del admin (banner arriba del Dashboard) ──
     Vive dentro de config/main.announcement — ya se carga en _loadConfig()
     junto con el resto, sin lecturas extra. Se puede cerrar; queda cerrado
     hasta que el admin cambie el texto (comparamos contra el texto exacto). ── */
  function _renderAnnouncement() {
    const el = document.getElementById('sr-ch-announcement');
    if (!el) return;
    const ann = _config.announcement;
    if (!ann || !ann.active || !ann.text) { el.style.display = 'none'; el.innerHTML = ''; return; }
    if (localStorage.getItem('sr-ch-ann-dismissed') === ann.text) { el.style.display = 'none'; return; }
    el.innerHTML =
      '<div class="sr-ch-announcement-banner">' +
        '<span class="sr-ch-announcement-icon">📣</span>' +
        '<span class="sr-ch-announcement-text">' + chEscape(ann.text) + '</span>' +
        '<button type="button" class="sr-ch-announcement-close" onclick="ChampionsApp.dismissAnnouncement()" aria-label="Cerrar aviso">✕</button>' +
      '</div>';
    el.style.display = 'block';
  }

  function dismissAnnouncement() {
    const text = _config.announcement && _config.announcement.text;
    if (text) localStorage.setItem('sr-ch-ann-dismissed', text);
    const el = document.getElementById('sr-ch-announcement');
    if (el) el.style.display = 'none';
  }

  /* ── Recordatorio de partidos sin predecir en la jornada activa ── */
  async function _renderNudge() {
    const el = document.getElementById('sr-ch-nudge');
    if (!el || !_user) return;
    el.style.display = 'none';
    try {
      const activeJ = _config.jornadasActivas || [];
      if (activeJ.length === 0) return;
      const j = activeJ[activeJ.length - 1];
      const matchSnap = await _db.collection('matches').where('phase', '==', 'league').where('matchday', '==', j).get();
      if (matchSnap.empty) return;

      const openIds = [];
      let earliestLock = null;
      matchSnap.forEach(doc => {
        const m = doc.data();
        if (_chIsClosed(m)) return;
        openIds.push(doc.id);
        const raw = m.lockAt || m.deadline;
        const dt = raw && raw.toDate ? raw.toDate() : new Date(raw);
        if (raw && (!earliestLock || dt < earliestLock)) earliestLock = dt;
      });
      if (openIds.length === 0) return;

      const predSnap = await _db.collection('users/' + _user.uid + '/ch_predictions').get();
      const predicted = new Set();
      predSnap.forEach(d => predicted.add(d.id));
      const missing = openIds.filter(id => !predicted.has(id));
      if (missing.length === 0) return;

      const tl = earliestLock ? chTimeLeft(earliestLock) : null;
      el.innerHTML =
        '<div class="sr-ch-nudge-banner" onclick="ChampionsApp.showScreen(\'liga\', {jornada:' + j + '})">' +
          '<span class="sr-ch-nudge-icon">⏰</span>' +
          '<span class="sr-ch-nudge-text">Te ' + (missing.length === 1 ? 'falta 1 partido' : 'faltan ' + missing.length + ' partidos') +
            ' por predecir en la Jornada ' + j + (tl ? ' · cierra en ' + chEscape(tl.label) : '') + '</span>' +
          '<span class="sr-ch-nudge-cta">Predecir →</span>' +
        '</div>';
      el.style.display = 'block';
    } catch(e) { /* si falla, simplemente no se muestra el recordatorio */ }
  }

  function _chGetAudioCtx() {
    try {
      if (!_chAudioCtx || _chAudioCtx.state === 'closed') {
        _chAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
      }
      return _chAudioCtx;
    } catch(e) { return null; }
  }

  function _chPlayCelebrationSound() {
    if (!_chSoundEnabled) return;
    const ctx = _chGetAudioCtx();
    if (!ctx) return;
    try {
      [523, 659, 784, 1047, 1319].forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.type = i < 4 ? 'triangle' : 'sine';
        osc.frequency.value = freq;
        const t = ctx.currentTime + i * 0.12;
        gain.gain.setValueAtTime(0.18, t);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.4);
        osc.start(t); osc.stop(t + 0.45);
      });
    } catch(e) {}
  }

  /* ── Celebración: puntos ganados desde la última visita ──
     El admin carga resultados y recalcula puntos en segundo plano — el usuario
     se entera recién cuando vuelve a entrar. Comparamos contra el último total
     visto en este dispositivo (localStorage) para mostrar cuánto ganó de nuevo. ── */
  function _checkPointsCelebration(pts) {
    if (!_user) return;
    const key = 'sr-ch-pts-' + _user.uid;
    const prevPts = parseInt(localStorage.getItem(key) || '0', 10);
    if (pts > prevPts && prevPts > 0) {
      setTimeout(() => { _chShowFloatingPoints(pts - prevPts); _chPlayCelebrationSound(); }, 500);
    }
    localStorage.setItem(key, String(pts));
  }

  function _chShowFloatingPoints(pts) {
    if (!pts || pts <= 0) return;
    const el = document.createElement('div');
    el.className = 'sr-ch-float-pts';
    el.textContent = '+' + pts + ' pts ⚽';
    document.body.appendChild(el);
    setTimeout(() => { if (el.parentNode) el.remove(); }, 1900);
  }

  /* ── Celebración: subida de puestos en el ranking desde la última visita ── */
  function _checkRankCelebration(newPos) {
    if (!newPos || newPos < 1 || !_user) return;
    const key = 'sr-ch-rank-' + _user.uid;
    const prev = parseInt(localStorage.getItem(key) || '0', 10);
    localStorage.setItem(key, String(newPos));
    if (prev > 0 && newPos < prev) {
      setTimeout(() => _chShowRankCelebration(prev, newPos), 900);
    }
  }

  function _chShowRankCelebration(fromPos, toPos) {
    if (document.querySelector('.sr-ch-rank-celebrate')) return;
    const sub = toPos === 1 ? '👑 ¡Sos el líder!' : toPos <= 3 ? '🏅 ¡Estás en el podio!' : '¡Seguí así, vas subiendo!';
    const overlay = document.createElement('div');
    overlay.className = 'sr-ch-rank-celebrate';
    overlay.innerHTML =
      '<div class="sr-ch-rank-celebrate__card">' +
        '<span class="sr-ch-rank-celebrate__icon">🚀</span>' +
        '<div class="sr-ch-rank-celebrate__title">¡SUBISTE EN EL RANKING!</div>' +
        '<div class="sr-ch-rank-celebrate__from">#' + fromPos + ' → <span>#' + toPos + '</span></div>' +
        '<div class="sr-ch-rank-celebrate__sub">' + sub + '</div>' +
      '</div>';
    overlay.addEventListener('click', () => overlay.remove());
    document.body.appendChild(overlay);
    _chPlayCelebrationSound();
    setTimeout(() => { if (overlay.parentNode) overlay.remove(); }, 9000);
  }

  /* ── Posición en el ranking (chip en el hero del dashboard) ── */
  async function _loadDashRank() {
    const rankEl = document.getElementById('sr-ch-dash-rank');
    if (!rankEl || !_user) return;
    try {
      const rows = (await _chGetAllProfiles()).map(p => ({ uid: p.uid, pts: p.totalPoints }));
      rows.sort((a, b) => b.pts - a.pts);
      const pos   = rows.findIndex(r => r.uid === _user.uid) + 1;
      const total = rows.length;
      if (pos > 0 && total > 1) {
        rankEl.textContent = '📍 #' + pos + ' de ' + total;
        rankEl.style.display = 'inline-flex';
        _checkRankCelebration(pos);
      } else {
        rankEl.style.display = 'none';
      }
    } catch(e) {
      rankEl.style.display = 'none';
    }
  }

  function _renderThermo(pts) {
    const prizes = _prizesData.length > 0
      ? _prizesData
      : CH_DATA.termometro.map(t => ({ id: t.nivel, pts: t.pts, title: t.label, icon: t.icon }));
    if (!prizes.length) return;

    const maxPts = prizes[prizes.length - 1].pts;
    const pct    = Math.min((pts / maxPts) * 100, 100);
    const fill   = document.getElementById('sr-ch-thermo-fill');
    const markEl = document.getElementById('sr-ch-thermo-markers');
    const nextEl = document.getElementById('sr-ch-thermo-next');
    const ptsHeadEl = document.getElementById('sr-ch-thermo-pts');
    if (ptsHeadEl) ptsHeadEl.textContent = pts + ' / ' + maxPts + ' pts';
    if (!fill) return;

    setTimeout(() => {
      fill.style.width = pct + '%';
      if (pts > 0) fill.classList.add('has-progress');
      else fill.classList.remove('has-progress');
    }, 120);

    if (markEl) {
      // Compact dot row
      let html = '<div style="display:flex;justify-content:space-between;margin-bottom:14px">';
      prizes.forEach(p => {
        const reached = pts >= p.pts;
        html += '<div class="sr-ch-thermo-marker' + (reached ? ' reached' : '') + '">' +
          '<div class="sr-ch-thermo-dot">' + chEscape(p.icon || '🏆') + '</div>' +
          '<div class="sr-ch-thermo-marker-pts">' + (p.pts || 0) + '</div>' +
        '</div>';
      });
      html += '</div>';

      // Prize cards with sponsor info
      html += '<div style="display:flex;flex-direction:column;gap:7px">';
      prizes.forEach(p => {
        const reached = pts >= p.pts;
        const hasSponsor = !!(p.sponsorName || p.sponsorLogo);
        html += '<div style="display:flex;align-items:center;gap:10px;padding:10px 14px;border-radius:12px;' +
          (reached
            ? 'background:rgba(255,20,100,.08);border:1px solid rgba(255,20,100,.2)'
            : 'background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.06)') +
          '">' +
          '<div style="font-size:22px;line-height:1;flex-shrink:0">' + chEscape(p.icon || '🏆') + '</div>' +
          '<div style="flex:1;min-width:0">' +
            '<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:' + (hasSponsor ? '4' : '0') + 'px">' +
              '<span style="font-size:11px;font-weight:800;font-family:\'Bebas Neue\',sans-serif;letter-spacing:1px;color:' + (reached ? '#FF1464' : 'rgba(155,170,204,.5)') + '">' + (p.pts || 0) + ' pts</span>' +
              '<span style="font-size:12px;font-weight:700;color:' + (reached ? '#F1F5F9' : 'rgba(155,170,204,.6)') + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:160px">' + chEscape(p.title || '') + '</span>' +
            '</div>' +
            (hasSponsor ?
              '<div style="display:flex;align-items:center;gap:6px">' +
                '<span style="font-size:7px;letter-spacing:2px;color:rgba(155,170,204,.35);font-weight:700;white-space:nowrap">PATROCINADO POR</span>' +
                (p.sponsorLogo
                  ? '<img src="' + chEscape(p.sponsorLogo) + '" alt="' + chEscape(p.sponsorName || '') + '" style="height:18px;max-width:80px;object-fit:contain;vertical-align:middle;opacity:' + (reached ? '1' : '.5') + '">'
                  : '<span style="font-size:10px;font-weight:700;color:rgba(255,255,255,' + (reached ? '.7' : '.3') + ')">' + chEscape(p.sponsorName || '') + '</span>'
                ) +
              '</div>'
              : ''
            ) +
          '</div>' +
          (reached
            ? '<div style="font-size:16px;flex-shrink:0">✅</div>'
            : '<div style="font-size:10px;font-weight:700;color:rgba(155,170,204,.3);letter-spacing:.5px;flex-shrink:0;text-align:right">' + ((p.pts || 0) - pts) + '<br><span style="font-size:8px;letter-spacing:1px">pts</span></div>'
          ) +
        '</div>';
      });
      html += '</div>';

      markEl.innerHTML = html;
    }

    if (nextEl) {
      const next = prizes.find(p => pts < p.pts);
      nextEl.innerHTML = next
        ? 'Tenés <strong>' + pts + ' pts</strong> — faltan <strong>' + ((next.pts || 0) - pts) + '</strong> para ' + chEscape(next.icon || '🏆') + ' ' + chEscape(next.title || '')
        : '<strong>🎉 ¡Nivel máximo alcanzado!</strong>';
    }
  }

  function _updateHeader(pts, name, lvl) {
    const unameEl = document.getElementById('sr-ch-header-uname');
    if (unameEl) unameEl.textContent = (name || '—').toUpperCase();

    const avatarEl = document.getElementById('sr-ch-header-avatar');
    if (avatarEl) avatarEl.textContent = name ? name.charAt(0).toUpperCase() : '?';

    const ptsEl = document.getElementById('sr-ch-header-pts');
    if (ptsEl) ptsEl.textContent = (pts || 0) + ' pts';

    const hlvlEl = document.getElementById('sr-ch-header-hlvl');
    if (hlvlEl) hlvlEl.textContent = lvl ? lvl.icon + ' ' + lvl.label : 'Champions 2026/27';
  }

  async function _loadProximos() {
    const cont = document.getElementById('sr-ch-dash-proximos');
    if (!cont) return;
    try {
      // "lockAt" se guarda como string ISO (ver saveMatchData/createTestMatch en el
      // admin) — comparar contra un Timestamp de Firestore es un tipo distinto y JAMÁS
      // matchea nada (bug real: este widget aparecía vacío sin importar los partidos
      // que hubiera). Los strings ISO 8601 sí se pueden comparar como texto ("mayor que"
      // funciona igual que con fechas reales). "deadline" es un campo legado que, si
      // existe en algún documento viejo, sí es un Timestamp — se mantiene ese fallback.
      const nowISO = new Date().toISOString();
      const nowTs  = firebase.firestore.Timestamp.fromDate(new Date());
      // Sin orderBy para evitar índice compuesto; filtrar y ordenar en JS
      let snap = await _db.collection('matches').where('lockAt', '>', nowISO).get();
      if (snap.empty) {
        snap = await _db.collection('matches').where('deadline', '>', nowTs).get();
      }
      // El partido de prueba SÍ debe aparecer acá cuando el admin lo posicionó en una
      // fase real (liga/eliminatorias) — la idea es que recorra el sistema exactamente
      // como un partido real, útil para verificar todo y hacer demos a patrocinadores.
      // Solo se excluye mientras esté en fase "test" (oculto a propósito).
      const docs = [];
      snap.forEach(doc => {
        const d = doc.data();
        if (d.phase === 'test') return;
        docs.push(d);
      });
      docs.sort((a, b) => {
        const ta = (a.lockAt || a.deadline)?.toDate?.() || new Date(a.lockAt || a.deadline || 0);
        const tb = (b.lockAt || b.deadline)?.toDate?.() || new Date(b.lockAt || b.deadline || 0);
        return ta - tb;
      });
      const visible = docs.slice(0, 5);

      if (visible.length === 0) {
        cont.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:20px">No hay partidos próximos</div>';
        return;
      }
      const phToFase = { r16:'octavos', qf:'cuartos', sf:'semifinal', final:'final', playoff:'playoff' };
      let html = '';
      visible.forEach((m, i) => {
        const lockTs  = m.lockAt || m.deadline;
        const tl      = chTimeLeft(lockTs);
        const homeTeam = m.homeTeamName || m.local || '?';
        const awayTeam = m.awayTeamName || m.visitante || '?';
        const homeFlag = m.homeTeamFlag || m.flagLocal || '⚽';
        const awayFlag = m.awayTeamFlag || m.flagVisitante || '⚽';
        const homeCrest = m.homeTeamCrest || '';
        const awayCrest = m.awayTeamCrest || '';
        const tlColor  = tl.status === 'soon' ? '#f59e0b' : 'var(--ch-text2)';

        const phase    = m.phase || 'league';
        const isLeague = phase === 'league';
        const faseId   = phToFase[phase] || phase;
        const faseObj  = isLeague ? null : CH_DATA.fases.find(f => f.id === faseId);
        const tag      = isLeague ? ('J' + (m.matchday || '?')) : (faseObj ? faseObj.nombre.replace(' DE FINAL','').replace('GRAN ','') : '');
        const navAttr  = isLeague
          ? 'ChampionsApp.showScreen(\'liga\', {jornada:' + (m.matchday || 0) + '})'
          : 'ChampionsApp.showScreen(\'eliminatorias\', {fase:\'' + faseId + '\'})';

        const venue = m.venue || m.estadio || '';

        if (i === 0) {
          // El más urgente se destaca como tarjeta protagonista, no como una fila más de la lista
          html += '<div class="sr-ch-proximo-hero' + (tl.status === 'soon' ? ' soon' : '') + '" onclick="' + navAttr + '" title="Ir a predecir este partido">' +
            '<div class="sr-ch-proximo-hero__top">' +
              '<span class="sr-ch-proximo-hero__badge">⏰ PRÓXIMO CIERRE' +
                (tag ? ' · ' + chEscape(tag) : '') + '</span>' +
              '<span class="sr-ch-proximo-hero__time" style="color:' + tlColor + '">' + tl.label + '</span>' +
            '</div>' +
            '<div class="sr-ch-proximo-hero__match">' +
              '<div class="sr-ch-proximo-hero__team">' + chBadgeHTML(homeCrest, homeFlag, 30) +
                '<span>' + chEscape(homeTeam) + '</span></div>' +
              '<span class="sr-ch-proximo-hero__vs">VS</span>' +
              '<div class="sr-ch-proximo-hero__team">' + chBadgeHTML(awayCrest, awayFlag, 30) +
                '<span>' + chEscape(awayTeam) + '</span></div>' +
            '</div>' +
            (venue ? '<div class="sr-ch-proximo-hero__venue">📍 ' + chEscape(venue) + '</div>' : '') +
          '</div>';
        } else {
          html += '<div class="sr-ch-proximo-row" onclick="' + navAttr + '" title="Ir a predecir este partido">' +
            '<div class="sr-ch-proximo-row__match">' +
              (tag ? '<span class="sr-ch-proximo-row__tag">' + chEscape(tag) + '</span>' : '') +
              chBadgeHTML(homeCrest, homeFlag, 18) +
              '<span class="sr-ch-proximo-row__names">' + chEscape(homeTeam) +
                ' <span class="sr-ch-proximo-row__vs">vs</span> ' + chEscape(awayTeam) + '</span>' +
              chBadgeHTML(awayCrest, awayFlag, 18) +
            '</div>' +
            '<span class="sr-ch-proximo-row__time" style="color:' + tlColor + '">' + tl.label + ' ›</span>' +
          '</div>';
        }
      });
      cont.innerHTML = html;
    } catch(e) {
      cont.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:20px">Sin partidos próximos</div>';
    }
  }

  /* ── Fase de Liga ──────────────────────────────────── */
  async function _renderLiga(preferJ) {
    const tabsEl  = document.getElementById('sr-ch-jornada-tabs');
    const contEl  = document.getElementById('sr-ch-liga-content');
    if (!tabsEl || !contEl) return;

    const activeJornadas = _config.jornadasActivas || [];

    // Si hay partido de prueba en liga, desbloquear su jornada sin tocar la config real
    let testJornada = null;
    try {
      const tSnap = await _db.doc('matches/test_match').get();
      if (tSnap.exists) { const td = tSnap.data(); if (td.phase === 'league' && td.matchday) testJornada = td.matchday; }
    } catch(e) {}
    const unlockedJ = testJornada ? [...new Set([...activeJornadas, testJornada])] : activeJornadas;

    const jornadas = [1,2,3,4,5,6,7,8];
    tabsEl.innerHTML = jornadas.map(j => {
      const locked = !unlockedJ.includes(j);
      return '<button class="sr-ch-jornada-tab' + (locked ? ' locked' : '') + '"' +
        (locked ? ' disabled title="Jornada no disponible aún"' : ' onclick="ChampionsApp.loadJornada(' + j + ')"') +
        '>Jornada ' + j + '</button>';
    }).join('');

    if (unlockedJ.length > 0) {
      // Si viene una jornada puntual pedida (ej. desde "Próximos Cierres") y está
      // desbloqueada, priorizarla. Si no, preferir última jornada real activa,
      // y caer en jornada de prueba solo si no hay reales.
      const autoJ = (preferJ && unlockedJ.includes(preferJ))
        ? preferJ
        : (activeJornadas.length > 0 ? activeJornadas[activeJornadas.length - 1] : testJornada);
      loadJornada(autoJ);
    } else {
      contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">La fase de liga aún no está disponible.</div>';
    }
  }

  async function loadJornada(j) {
    const contEl = document.getElementById('sr-ch-liga-content');
    if (!contEl) return;
    document.querySelectorAll('#sr-ch-jornada-tabs .sr-ch-jornada-tab').forEach((btn, i) => {
      btn.classList.toggle('active', i + 1 === j);
    });
    contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">Cargando jornada ' + j + '...</div>';
    try {
      // Sin orderBy para evitar requerir índices compuestos; ordenar en JS
      let matchSnap = await _db.collection('matches')
        .where('phase', '==', 'league').where('matchday', '==', j).get();
      if (matchSnap.empty) {
        matchSnap = await _db.collection('matches')
          .where('fase', '==', 'liga').where('jornada', '==', j).get();
      }

      if (matchSnap.empty) {
        contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">No hay partidos cargados para esta jornada.</div>';
        return;
      }

      const preds = {};
      try {
        const predSnap = await _db.collection('users/' + _user.uid + '/ch_predictions').get();
        predSnap.forEach(d => { preds[d.id] = d.data(); });
      } catch(pe) { console.warn('[Champions] predictions load failed:', pe.code || pe.message); }

      const matchDocs = [];
      matchSnap.forEach(doc => matchDocs.push({ id: doc.id, ...doc.data() }));
      matchDocs.sort((a, b) => (a.matchOrder ?? a.num ?? 0) - (b.matchOrder ?? b.num ?? 0));

      const totalM = matchDocs.length;
      const doneM  = matchDocs.filter(m => preds[m.id]).length;
      const pctM   = totalM > 0 ? Math.round((doneM / totalM) * 100) : 0;
      let html = '<div style="display:flex;align-items:center;gap:12px;margin-bottom:16px;padding:12px 16px;' +
        'background:var(--ch-surface);border:1px solid var(--ch-border);border-radius:12px">' +
        '<span style="font-size:11px;font-weight:700;letter-spacing:1px;color:var(--ch-text2);white-space:nowrap">' +
          'JORNADA ' + j + '</span>' +
        '<div style="flex:1;height:6px;background:var(--ch-raised);border-radius:4px;overflow:hidden">' +
          '<div style="height:100%;width:' + pctM + '%;background:linear-gradient(90deg,#FF1464,#9B5DFF);border-radius:4px;transition:width .6s cubic-bezier(0.22,1,0.36,1)"></div>' +
        '</div>' +
        '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:15px;color:' + (doneM === totalM ? '#4ADE80' : 'var(--ch-gold)') + ';white-space:nowrap">' +
          doneM + '/' + totalM + (doneM === totalM ? ' ✅' : '') +
        '</span>' +
      '</div>';
      const toggleBtn = document.getElementById('sr-ch-quickmode-toggle');
      if (toggleBtn) toggleBtn.classList.toggle('on', _chQuickMode);

      if (_chQuickMode) {
        html += '<div class="sr-ch-quick-list">';
        matchDocs.forEach(m => { html += _matchRowQuick(m.id, m, preds[m.id], _chIsClosed(m)); });
        html += '</div>';
        const anyOpen = matchDocs.some(m => !_chIsClosed(m));
        if (anyOpen) {
          html += '<button type="button" class="sr-ch-btn sr-ch-btn-primary sr-ch-quick-saveall" onclick="ChampionsApp.saveAllQuick(' + j + ')" style="width:100%;justify-content:center;margin-top:14px">💾 GUARDAR TODO</button>';
        }
      } else {
        matchDocs.forEach(m => {
          const closed = _chIsClosed(m);
          html += _matchCard(m.id, m, preds[m.id], closed);
        });
      }
      contEl.innerHTML = html;
      _attachMatchSave();
    } catch(err) {
      console.error('[Champions] loadJornada error:', err);
      contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">Error: ' + (err.code || err.message || 'desconocido') + '</div>';
    }
  }

  /* ── Predicción rápida: modo alternativo, denso, para cargar toda una
     jornada de un tirón en vez de partido por partido ── */
  let _chQuickMode = (typeof localStorage !== 'undefined' && localStorage.getItem('sr-ch-quickmode') === '1');

  function toggleQuickMode() {
    _chQuickMode = !_chQuickMode;
    localStorage.setItem('sr-ch-quickmode', _chQuickMode ? '1' : '0');
    const btn = document.getElementById('sr-ch-quickmode-toggle');
    if (btn) btn.classList.toggle('on', _chQuickMode);
    const activeTab = document.querySelector('#sr-ch-jornada-tabs .sr-ch-jornada-tab.active');
    const idx = activeTab ? Array.from(activeTab.parentElement.children).indexOf(activeTab) : -1;
    if (idx >= 0) loadJornada(idx + 1);
  }

  function _matchRowQuick(mid, m, pred, closed) {
    const homeTeam = m.homeTeamName || m.local || 'Por definir';
    const awayTeam = m.awayTeamName || m.visitante || 'Por definir';
    const homeFlag = m.homeTeamFlag || m.flagLocal || '⚽';
    const awayFlag = m.awayTeamFlag || m.flagVisitante || '⚽';
    const homeCrest = m.homeTeamCrest || '';
    const awayCrest = m.awayTeamCrest || '';
    const hasPred = pred && (pred.homeScore != null || pred.localScore != null);
    const scoreHome = hasPred ? (pred.homeScore != null ? pred.homeScore : (pred.localScore ?? '')) : '';
    const scoreAway = hasPred ? (pred.awayScore != null ? pred.awayScore : (pred.visitanteScore ?? '')) : '';
    const firstScorer = hasPred ? (pred.firstScoringTeam || '') : '';
    const ro = closed ? ' readonly disabled' : '';

    const scorerBtn = (val, label) => {
      const isActive = firstScorer === val;
      return '<button type="button" class="sr-ch-qk-scorer-btn' + (isActive ? ' active' : '') + '" data-val="' + val + '"' + (closed ? ' disabled' : '') + '>' + label + '</button>';
    };

    return '<div class="sr-ch-quick-row' + (closed ? ' closed' : '') + '" data-mid="' + chEscape(mid) + '">' +
      '<div class="sr-ch-qk-team">' + chBadgeHTML(homeCrest, homeFlag, 20) + '<span>' + chEscape(homeTeam) + '</span></div>' +
      '<input class="sr-ch-qk-score" type="number" min="0" max="20"' + ro + ' value="' + chEscape(String(scoreHome)) + '" placeholder="—" data-role="home">' +
      '<span class="sr-ch-qk-sep">—</span>' +
      '<input class="sr-ch-qk-score" type="number" min="0" max="20"' + ro + ' value="' + chEscape(String(scoreAway)) + '" placeholder="—" data-role="away">' +
      '<div class="sr-ch-qk-team right"><span>' + chEscape(awayTeam) + '</span>' + chBadgeHTML(awayCrest, awayFlag, 20) + '</div>' +
      (closed
        ? '<span class="sr-ch-qk-closed">🔒</span>'
        : '<div class="sr-ch-qk-scorer">' + scorerBtn('home', '1') + scorerBtn('none', 'X') + scorerBtn('away', '2') + '</div>'
      ) +
    '</div>';
  }

  async function saveAllQuick(j) {
    if (!_user) return;
    const rows = document.querySelectorAll('#sr-ch-liga-content .sr-ch-quick-row:not(.closed)');
    const btn = document.querySelector('.sr-ch-quick-saveall');
    if (btn) { btn.disabled = true; btn.textContent = 'Guardando...'; }

    // Revalidar contra el estado REAL de cada partido antes de escribir —
    // mismo motivo que en savePred(): el DOM (la clase "closed" ya calculada
    // al renderizar) puede haber quedado desactualizado si la pestaña quedó
    // abierta pasado el cierre. Antes esto NO se revisaba acá, así que
    // "GUARDAR TODO" podía escribir predicciones en partidos ya cerrados.
    const rowsArr = Array.from(rows);
    let freshById = {};
    try {
      const freshSnaps = await Promise.all(rowsArr.map(row => _db.doc('matches/' + row.dataset.mid).get()));
      freshSnaps.forEach(snap => { if (snap.exists) freshById[snap.id] = snap.data(); });
    } catch(e) { /* si la verificación falla por red, no bloquear un guardado legítimo */ }

    const batch = _db.batch();
    let ready = 0, incomplete = 0, closedNow = 0;
    rowsArr.forEach(row => {
      const mid = row.dataset.mid;
      const fresh = freshById[mid];
      if (fresh && _chIsClosed(fresh)) {
        closedNow++;
        row.classList.add('closed');
        row.querySelectorAll('.sr-ch-qk-score').forEach(inp => inp.setAttribute('readonly', 'readonly'));
        row.querySelectorAll('.sr-ch-qk-scorer-btn').forEach(b => b.disabled = true);
        return;
      }
      const homeVal = row.querySelector('.sr-ch-qk-score[data-role="home"]').value.trim();
      const awayVal = row.querySelector('.sr-ch-qk-score[data-role="away"]').value.trim();
      const activeScorer = row.querySelector('.sr-ch-qk-scorer-btn.active');
      if (homeVal === '' || awayVal === '' || !activeScorer) { incomplete++; return; }
      const homeScore = Math.floor(Number(homeVal));
      const awayScore = Math.floor(Number(awayVal));
      const firstScoringTeam = activeScorer.dataset.val;
      if (isNaN(homeScore) || isNaN(awayScore) || homeScore < 0 || awayScore < 0 || homeScore > 20 || awayScore > 20) { incomplete++; return; }
      if (homeScore === 0 && awayScore === 0 && firstScoringTeam !== 'none') { incomplete++; return; }
      if ((homeScore > 0 || awayScore > 0) && firstScoringTeam === 'none') { incomplete++; return; }
      ready++;
      row.classList.add('predicted');
      batch.set(_db.doc('users/' + _user.uid + '/ch_predictions/' + mid), {
        homeScore, awayScore, firstScoringTeam,
        localScore: homeScore, visitanteScore: awayScore,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        submittedAt: firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true });
    });

    if (ready === 0) {
      chNotif(closedNow > 0
        ? '🔒 ' + closedNow + ' partido' + (closedNow === 1 ? '' : 's') + ' ya cerró/cerraron mientras tanto'
        : 'Completá marcador y anotador de al menos un partido', 'error');
      if (btn) { btn.disabled = false; btn.textContent = '💾 GUARDAR TODO'; }
      return;
    }

    try {
      await batch.commit();
      let msg = '✅ Guardadas ' + ready + ' predicciones';
      if (incomplete > 0) msg += ' · ' + incomplete + ' quedaron incompletas';
      if (closedNow > 0) msg += ' · ' + closedNow + ' ya habían cerrado';
      chNotif(msg, 'success');
      loadJornada(j);
    } catch(e) {
      chNotif('Error al guardar. Intentá de nuevo.', 'error');
      if (btn) { btn.disabled = false; btn.textContent = '💾 GUARDAR TODO'; }
    }
  }

  /* ── Eliminatorias ─────────────────────────────────── */
  async function _renderEliminatorias(preferFase) {
    const tabsEl = document.getElementById('sr-ch-elim-tabs');
    const contEl = document.getElementById('sr-ch-elim-content');
    if (!tabsEl || !contEl) return;

    const fases = CH_DATA.fases.filter(f => f.tipo !== 'liga');

    // Admin guarda phase keys ('r16','qf','sf'); usuario maneja ids ('octavos','cuartos','semifinal').
    // Normalizamos para que ambos formatos funcionen sin depender de cuál guardó el admin.
    const _phToFase = { r16:'octavos', qf:'cuartos', sf:'semifinal', final:'final', playoff:'playoff' };
    const rawActivas = _config.fasesActivas || [];
    const activas = [...new Set([
      ...rawActivas,
      ...rawActivas.map(a => _phToFase[a] || a)
    ])];

    // Si hay partido de prueba en una fase eliminatoria, desbloquear esa fase
    let testFaseId = null;
    try {
      const tSnap = await _db.doc('matches/test_match').get();
      if (tSnap.exists) { const td = tSnap.data(); if (_phToFase[td.phase]) testFaseId = _phToFase[td.phase]; }
    } catch(e) {}
    const activasConTest = testFaseId ? [...new Set([...activas, testFaseId])] : activas;

    tabsEl.innerHTML = fases.map(f => {
      const locked = !activasConTest.includes(f.id);
      const label  = f.nombre.replace(' DE FINAL','').replace('GRAN ','');
      return '<button class="sr-ch-jornada-tab' + (locked ? ' locked' : '') + '"' +
        (locked ? ' disabled title="Fase no disponible aún"' : ' onclick="ChampionsApp.loadFaseElim(\'' + f.id + '\')"') +
        '>' + label + '</button>';
    }).join('');

    _renderBracket();

    if (activasConTest.length > 0) {
      // Si viene una fase puntual pedida y está desbloqueada, priorizarla.
      // Si no, preferir última fase real activa; caer en fase de prueba solo si no hay reales.
      const preferred = preferFase && activasConTest.includes(preferFase)
        ? fases.find(f => f.id === preferFase) : null;
      const lastReal = fases.filter(f => activas.includes(f.id)).pop();
      const autoFase = preferred || lastReal || fases.find(f => f.id === testFaseId);
      if (autoFase) loadFaseElim(autoFase.id);
    } else {
      contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">Las fases eliminatorias aún no están disponibles.</div>';
    }
  }

  /* ── Bracket ────────────────────────────────────────── */
  async function _renderBracket() {
    const outer = document.getElementById('sr-ch-bracket-outer');
    const cont  = document.getElementById('sr-ch-bracket-cont');
    if (!outer || !cont) return;

    const BK_PHASES = [
      { id: 'playoff',   label: 'PLAYOFF',  phaseKey: 'playoff', expected: 8 },
      { id: 'octavos',   label: '8VOS',     phaseKey: 'r16',     expected: 8 },
      { id: 'cuartos',   label: 'CUARTOS',  phaseKey: 'qf',      expected: 4 },
      { id: 'semifinal', label: 'SEMIS',    phaseKey: 'sf',      expected: 2 },
      { id: 'final',     label: 'FINAL',    phaseKey: 'final',   expected: 1 },
    ];

    try {
      const [snapResults, predSnap, qualSnap] = await Promise.all([
        Promise.all(BK_PHASES.map(async ph => {
          try {
            let s = await _db.collection('matches').where('phase', '==', ph.phaseKey).get();
            if (s.empty) s = await _db.collection('matches').where('fase', '==', ph.id).get();
            return { id: ph.id, snap: s };
          } catch(e) { return { id: ph.id, snap: null }; }
        })),
        _db.collection('users/' + _user.uid + '/ch_predictions').get().catch(() => null),
        _db.collection('users/' + _user.uid + '/ch_qualifiers').get().catch(() => null)
      ]);

      const preds = {};
      if (predSnap) predSnap.forEach(d => { preds[d.id] = d.data(); });

      const quals = {};
      if (qualSnap) qualSnap.forEach(d => { quals[d.id] = (d.data() || {}).qualifiedTeamId; });

      const byFase = {};
      snapResults.forEach(({ id, snap }) => {
        if (!snap) { byFase[id] = []; return; }
        const pairs = {};
        snap.forEach(doc => {
          const m = doc.data(), mid = doc.id;
          const key = m.tieId || m.eliminatoria || mid;
          if (!pairs[key]) pairs[key] = [];
          pairs[key].push({ id: mid, ...m, pred: preds[mid] || null });
        });
        Object.values(pairs).forEach(legs => legs.sort((a, b) => (a.leg || 0) - (b.leg || 0)));
        byFase[id] = Object.entries(pairs).sort(([a], [b]) => a.localeCompare(b));
      });

      outer.style.display = '';
      cont.innerHTML = _buildBracketHTML(BK_PHASES, byFase, _config.bracketSponsor || null, quals);
    } catch(e) {
      console.warn('[Champions] bracket error:', e);
      outer.style.display = '';
      cont.innerHTML = _buildBracketHTML(BK_PHASES, {}, (_config && _config.bracketSponsor) || null, {});
    }
  }

  function _buildBracketHTML(phases, byFase, sponsor, quals) {
    const minH       = Math.max(8 * 76, 400);
    const mainPhases = phases.filter(ph => ph.id !== 'playoff');
    let html = '';

    // Sponsor banner
    if (sponsor && sponsor.name) {
      html += '<div class="sr-ch-bk-sponsor">';
      if (sponsor.logo) {
        html += '<img class="sr-ch-bk-sponsor-logo" src="' + chEscape(sponsor.logo) +
                '" alt="' + chEscape(sponsor.name) + '">';
      }
      html += '<div class="sr-ch-bk-sponsor-text">' +
                '<span class="sr-ch-bk-sponsor-label">PRESENTADO POR</span>' +
                '<span class="sr-ch-bk-sponsor-name">' + chEscape(sponsor.name) + '</span>' +
              '</div></div>';
    }

    html += '<div class="sr-ch-bk-scroll-hint">← deslizá →</div>';
    html += '<div class="sr-ch-bk-wrap"><div class="sr-ch-bk-inner" style="--bk-min-h:' + minH + 'px">';

    // ── PLAYOFF column (always 8 slots, single 1:1 connectors) ──
    const playoffPairs = byFase['playoff'] || [];
    const paddedPlayoff = [...playoffPairs];
    while (paddedPlayoff.length < 8) paddedPlayoff.push(null);
    html += '<div class="sr-ch-bk-col sr-ch-bk-col--playoff">';
    html += '<div class="sr-ch-bk-col-label">⚡ PLAYOFF</div>';
    html += '<div class="sr-ch-bk-matches">';
    paddedPlayoff.forEach((p, i) => {
      html += '<div class="sr-ch-bk-group">' +
        _bkSlot(p, 'playoff', 'single', true, false, false, i + 1, quals) +
      '</div>';
    });
    html += '</div></div>';

    // ── Main phases (8VOS → CUARTOS → SEMIS → FINAL) ──
    mainPhases.forEach((ph, ci) => {
      const pairs   = byFase[ph.id] || [];
      const isLast  = ci === mainPhases.length - 1;
      const isFinal = ph.id === 'final';

      html += '<div class="sr-ch-bk-col sr-ch-bk-col--' + ph.id + (isFinal ? ' sr-ch-bk-col--final' : '') + '">';
      html += '<div class="sr-ch-bk-col-label">' + _bkRoundIcon(ph.id) + ph.label + '</div>';
      html += '<div class="sr-ch-bk-matches">';

      if (isFinal) {
        html += '<div class="sr-ch-bk-group">' +
          _bkSlot(pairs[0] || null, ph.id, 'single', false, true, true, 1, quals) +
        '</div>';
      } else {
        const padded = [...pairs];
        while (padded.length < ph.expected) padded.push(null);
        if (padded.length % 2 !== 0) padded.push(null);
        for (let i = 0; i < padded.length; i += 2) {
          html += '<div class="sr-ch-bk-group">' +
            _bkSlot(padded[i],   ph.id, 'top', !isLast, true, false, i + 1, quals) +
            _bkSlot(padded[i+1], ph.id, 'bot', !isLast, true, false, i + 2, quals) +
          '</div>';
        }
      }

      html += '</div></div>';
    });

    html += '</div></div>';
    return html;
  }

  function _bkRoundIcon(id) {
    return { playoff:'⚡ ', octavos:'🎯 ', cuartos:'⚔️ ', semifinal:'🔥 ', final:'🏆 ' }[id] || '';
  }

  function _bkSlot(pair, faseId, pos, connects, receives, isFinal, encNum, quals) {
    const cls = ['sr-ch-bk-slot'];
    if (pos === 'top')    cls.push('sr-ch-bk-slot--top');
    if (pos === 'bot')    cls.push('sr-ch-bk-slot--bot');
    if (pos === 'single') cls.push('sr-ch-bk-slot--single');
    if (connects) cls.push('sr-ch-bk-slot--conn');
    if (receives) cls.push('sr-ch-bk-slot--recv');

    const ENC_PFX = { playoff:'PLAYOFF', octavos:'OCTAVO', cuartos:'CUARTO', semifinal:'SEMIFINAL', final:'GRAN FINAL' };
    const encLabel = isFinal ? 'GRAN FINAL' : (ENC_PFX[faseId] || 'ENCUENTRO') + ' ' + encNum;

    if (!pair) {
      return '<div class="' + cls.join(' ') + '">' +
        '<div class="sr-ch-bk-node sr-ch-bk-node--tbd" aria-label="' + encLabel + ': Por definir">' +
          '<div class="sr-ch-bk-enc">' + encLabel + '</div>' +
          '<div class="sr-ch-bk-teams">' +
            '<div class="sr-ch-bk-team"><span class="sr-ch-bk-name sr-ch-bk-name--pd">POR DEFINIR</span></div>' +
            '<div class="sr-ch-bk-vs">vs</div>' +
            '<div class="sr-ch-bk-team"><span class="sr-ch-bk-name sr-ch-bk-name--pd">POR DEFINIR</span></div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    const [tieKey, legs] = pair;
    const first = legs[0] || {};
    const home      = first.homeTeamName || first.local     || 'POR DEFINIR';
    const away      = first.awayTeamName || first.visitante || 'POR DEFINIR';
    const homeFlag  = first.homeTeamFlag || first.flagLocal     || '';
    const awayFlag  = first.awayTeamFlag || first.flagVisitante || '';
    const homeCrest = first.homeTeamCrest || '';
    const awayCrest = first.awayTeamCrest || '';
    const homeId    = first.homeTeamId || 'home';
    const awayId    = first.awayTeamId || 'away';
    const qualPick  = (quals || {})[tieKey];
    const myPickHtml = qualPick
      ? '<div class="sr-ch-bk-mypick">🔮 Tu pick: ' + chEscape(qualPick === homeId ? home : away) + '</div>'
      : '';

    const allPred   = legs.every(m => m.pred && (m.pred.homeScore != null || m.pred.localScore != null));
    const anyPred   = legs.some( m => m.pred && (m.pred.homeScore != null || m.pred.localScore != null));
    const allClosed = legs.every(_chIsClosed);
    const dateStr   = _bkFmtDate(first.lockAt || first.deadline);

    // Build result string for closed matches that have scores
    let resultHtml = '<div class="sr-ch-bk-vs">vs</div>';
    if (allClosed) {
      const scored = legs.filter(m => m.homeScore != null || m.localScore != null);
      if (scored.length === 1) {
        const s = scored[0];
        const hs = s.homeScore ?? s.localScore ?? '?';
        const as = s.awayScore ?? s.visitanteScore ?? '?';
        resultHtml = '<div class="sr-ch-bk-score">' + hs + ' — ' + as + '</div>';
      } else if (scored.length > 1) {
        const parts = scored.map((s, idx) => {
          const hs = s.homeScore ?? s.localScore ?? '?';
          const as = s.awayScore ?? s.visitanteScore ?? '?';
          return (idx === 0 ? 'IDA ' : 'VTA ') + hs + '-' + as;
        });
        resultHtml = '<div class="sr-ch-bk-score">' + parts.join(' · ') + '</div>';
      }
    }

    let sCls, sTxt;
    if (allClosed)      { sCls = 'closed';  sTxt = 'CERRADO';    }
    else if (allPred)   { sCls = 'ok';      sTxt = '✓ VATICINÉ'; }
    else if (anyPred)   { sCls = 'partial'; sTxt = 'INCOMPLETO'; }
    else                { sCls = 'pending'; sTxt = 'PENDIENTE';  }

    const nCls = ['sr-ch-bk-node'];
    if (allPred && !allClosed) nCls.push('sr-ch-bk-node--predicted');

    const oc  = 'ChampionsApp.navToBracketMatch(\'' + chEscape(faseId) + '\',\'' + chEscape(tieKey) + '\')';
    const lbl = chEscape(encLabel + ': ' + home + ' vs ' + away + (dateStr ? ', ' + dateStr : ''));

    return '<div class="' + cls.join(' ') + '">' +
      '<div class="' + nCls.join(' ') + '" onclick="' + oc + '" ' +
           'role="button" tabindex="0" aria-label="' + lbl + '" ' +
           'onkeydown="if(event.key===\'Enter\'||event.key===\' \'){event.preventDefault();' + oc + '}">' +
        '<div class="sr-ch-bk-enc">' + encLabel + '</div>' +
        '<div class="sr-ch-bk-teams">' +
          '<div class="sr-ch-bk-team">' +
            (homeFlag || homeCrest ? '<span>' + chBadgeHTML(homeCrest, homeFlag, 14) + '</span>' : '') +
            '<span class="sr-ch-bk-name" title="' + chEscape(home) + '">' + chEscape(home) + '</span>' +
          '</div>' +
          resultHtml +
          '<div class="sr-ch-bk-team">' +
            (awayFlag || awayCrest ? '<span>' + chBadgeHTML(awayCrest, awayFlag, 14) + '</span>' : '') +
            '<span class="sr-ch-bk-name" title="' + chEscape(away) + '">' + chEscape(away) + '</span>' +
          '</div>' +
        '</div>' +
        (dateStr ? '<div class="sr-ch-bk-date">' + dateStr + '</div>' : '') +
        myPickHtml +
        '<span class="sr-ch-bk-status ' + sCls + '">' + sTxt + '</span>' +
      '</div>' +
    '</div>';
  }

  function _bkFmtDate(ts) {
    if (!ts) return '';
    try {
      const d = ts.toDate ? ts.toDate() : new Date(ts);
      if (isNaN(d.getTime())) return '';
      const mo = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'][d.getMonth()];
      return d.getDate() + ' ' + mo + ' · ' + String(d.getHours()).padStart(2,'0') + ':' + String(d.getMinutes()).padStart(2,'0');
    } catch(e) { return ''; }
  }

  async function navToBracketMatch(faseId, tieKey) {
    await loadFaseElim(faseId);
    setTimeout(() => {
      const el     = document.querySelector('.sr-ch-elim-pair[data-tie="' + CSS.escape(tieKey) + '"]');
      const target = el || document.getElementById('sr-ch-elim-content');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (el) {
        el.style.transition = 'box-shadow .4s ease';
        el.style.boxShadow  = '0 0 0 2px rgba(255,20,100,.6), 0 0 24px rgba(255,20,100,.2)';
        setTimeout(() => { el.style.boxShadow = ''; }, 1800);
      }
    }, 520);
  }

  async function loadFaseElim(faseId) {
    const contEl = document.getElementById('sr-ch-elim-content');
    if (!contEl) return;

    const fases = CH_DATA.fases.filter(f => f.tipo !== 'liga');
    document.querySelectorAll('#sr-ch-elim-tabs .sr-ch-jornada-tab').forEach((btn, i) => {
      btn.classList.toggle('active', fases[i] && fases[i].id === faseId);
    });

    contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">Cargando...</div>';
    try {
      // Map legacy faseId to new spec phase value
      const phaseMap = { octavos: 'r16', cuartos: 'qf', semifinal: 'sf' };
      const newPhase = phaseMap[faseId] || faseId;

      // Sin orderBy para evitar requerir índices compuestos; ordenar en JS
      let matchSnap = await _db.collection('matches')
        .where('phase', '==', newPhase).get();
      if (matchSnap.empty) {
        matchSnap = await _db.collection('matches')
          .where('fase', '==', faseId).get();
      }

      const preds = {}, quals = {};
      try {
        const [predSnap, qualSnap] = await Promise.all([
          _db.collection('users/' + _user.uid + '/ch_predictions').get(),
          _db.collection('users/' + _user.uid + '/ch_qualifiers').get()
        ]);
        predSnap.forEach(d => { preds[d.id] = d.data(); });
        qualSnap.forEach(d => { quals[d.id] = d.data(); });
      } catch(pe) { console.warn('[Champions] elim preds/quals load failed:', pe.code || pe.message); }

      if (matchSnap.empty) {
        contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">No hay partidos cargados para esta fase.</div>';
        return;
      }

      // Agrupar por tieId, ordenar legs dentro de cada llave en JS
      const pairs = {};
      matchSnap.forEach(doc => {
        const m   = doc.data();
        const mid = doc.id;
        const key = m.tieId || m.eliminatoria || mid;
        if (!pairs[key]) pairs[key] = [];
        pairs[key].push({ id: mid, ...m, pred: preds[mid] });
      });
      Object.values(pairs).forEach(legs => legs.sort((a, b) => (a.leg || 0) - (b.leg || 0)));
      const sortedPairs = Object.entries(pairs).sort(([a], [b]) => a.localeCompare(b));

      let html = '';
      sortedPairs.forEach(([tieKey, legs]) => {
        const first  = legs[0] || {};
        const homeTeam = first.homeTeamName || first.local || '?';
        const awayTeam = first.awayTeamName || first.visitante || '?';
        const homeId   = first.homeTeamId || 'home';
        const awayId   = first.awayTeamId || 'away';

        // Llave header
        html += '<div class="sr-ch-elim-pair" data-tie="' + chEscape(tieKey) + '">' +
          '<div class="sr-ch-elim-header">' +
            '<div class="sr-ch-elim-teams">' +
              chEscape(homeTeam) + ' <span style="color:rgba(74,82,112,.4)">vs</span> ' + chEscape(awayTeam) +
            '</div>' +
          '</div>' +
          '<div class="sr-ch-elim-body">';

        // Each leg
        legs.forEach(m => {
          const closed = _chIsClosed(m);
          const legLabel = m.leg === 1 ? 'IDA' : m.leg === 2 ? 'VUELTA' : 'PARTIDO';
          html += '<div>' +
            '<div style="margin-bottom:6px"><span class="sr-ch-leg-badge">' + legLabel + '</span></div>' +
            _matchCard(m.id, m, m.pred, closed) +
          '</div>';
        });

        // Qualifier section — check if any leg is still open
        const allClosed = legs.every(_chIsClosed);
        const qualPred  = quals[tieKey];
        const qualSel   = qualPred ? qualPred.qualifiedTeamId : null;

        if (!allClosed) {
          html += '<div class="sr-ch-qualifier">' +
            '<div class="sr-ch-qualifier-label">¿Quién clasifica a la siguiente ronda?</div>' +
            '<div class="sr-ch-qualifier-btns">' +
              '<button class="sr-ch-qual-btn' + (qualSel === homeId ? ' active' : '') + '" data-tie="' + chEscape(tieKey) + '" data-team="' + chEscape(homeId) + '">' + chEscape(homeTeam) + '</button>' +
              '<button class="sr-ch-qual-btn' + (qualSel === awayId ? ' active' : '') + '" data-tie="' + chEscape(tieKey) + '" data-team="' + chEscape(awayId) + '">' + chEscape(awayTeam) + '</button>' +
            '</div>' +
            '<div class="sr-ch-qual-save-row">' +
              '<button class="sr-ch-btn sr-ch-btn-gold sr-ch-qual-save" data-tie="' + chEscape(tieKey) + '" style="font-size:11px;padding:7px 20px">' +
                (qualSel ? 'ACTUALIZAR' : 'GUARDAR CLASIFICADO') +
              '</button>' +
            '</div>' +
          '</div>';
        } else if (qualSel) {
          html += '<div class="sr-ch-locked-pred">Clasificado seleccionado: <strong>' +
            (qualSel === homeId ? chEscape(homeTeam) : chEscape(awayTeam)) +
          '</strong></div>';
        }

        html += '</div></div>';
      });
      contEl.innerHTML = html;
      _attachMatchSave();
    } catch(err) {
      console.error('[Champions] loadFaseElim error:', err);
      contEl.innerHTML = '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:40px">Error al cargar.</div>';
    }
  }

  /* ── Match card render ─────────────────────────────── */
  function _matchCard(mid, m, pred, closed) {
    const homeTeam = m.homeTeamName || m.local || 'Por definir';
    const awayTeam = m.awayTeamName || m.visitante || 'Por definir';
    const homeFlag = m.homeTeamFlag || m.flagLocal || '⚽';
    const awayFlag = m.awayTeamFlag || m.flagVisitante || '⚽';
    const homeCrest = m.homeTeamCrest || '';
    const awayCrest = m.awayTeamCrest || '';
    const venue    = m.venue || m.estadio || '';

    const hasPred = pred && (pred.homeScore != null || pred.localScore != null);
    const scoreHome = hasPred ? (pred.homeScore    != null ? pred.homeScore    : (pred.localScore    ?? '')) : '';
    const scoreAway = hasPred ? (pred.awayScore    != null ? pred.awayScore    : (pred.visitanteScore ?? '')) : '';
    const firstScorer = hasPred ? (pred.firstScoringTeam || '') : '';

    const lockTs = m.lockAt || m.deadline;
    const tl     = chTimeLeft(lockTs);
    const ro     = closed ? ' readonly' : '';

    // Resultado real + puntos ganados en ESTE partido (sin bono de racha, ver _chBasePoints)
    const finished = m.status === 'finished';
    const realHome = Number(m.homeScore ?? m.local ?? m.localScore);
    const realAway = Number(m.awayScore ?? m.visitante ?? m.visitanteScore);
    const hasRealScore = finished && !isNaN(realHome) && !isNaN(realAway);
    const basePts = finished ? _chBasePoints(pred, m, m.phase || 'league') : 0;

    const scorerBtn = function(val, label) {
      const isActive = firstScorer === val;
      return '<button class="sr-ch-scorer-btn' + (isActive ? ' active' : '') + '" data-mid="' + chEscape(mid) + '" data-val="' + val + '">' + label + '</button>';
    };

    return '<div class="sr-ch-match' + (hasPred ? ' predicted' : '') + (closed ? ' closed' : '') + '" id="match-' + chEscape(mid) + '" style="padding:0;overflow:hidden">' +

      // Gradient top bar
      '<div style="height:3px;background:linear-gradient(90deg,#FF1464 0%,#9B5DFF 50%,#00CFFF 100%)"></div>' +

      // Header: venue + countdown, con más presencia visual (punto vivo + pastilla de color)
      '<div class="sr-ch-match-header">' +
        '<span class="sr-ch-match-venue"><span class="pin">📍</span>' + chEscape(venue) + '</span>' +
        '<span class="sr-ch-match-countdown ' + tl.status + '"><span class="sr-ch-countdown-dot"></span>' + tl.label + '</span>' +
      '</div>' +

      // Teams + Score
      '<div style="display:grid;grid-template-columns:1fr auto 1fr;align-items:center;padding:22px 20px 20px;gap:10px">' +
        // Home team
        '<div style="text-align:center">' +
          '<div style="line-height:1;margin-bottom:10px">' + chBadgeHTML(homeCrest, homeFlag, 46) + '</div>' +
          '<div style="font-size:13px;font-weight:700;color:#F1F5F9;letter-spacing:.2px;line-height:1.3">' + chEscape(homeTeam) + '</div>' +
        '</div>' +
        // Score inputs
        '<div style="display:flex;flex-direction:column;align-items:center;gap:8px">' +
          '<div style="display:flex;align-items:center;gap:8px">' +
            '<input class="sr-ch-score-input" type="number" min="0" max="20" step="1" inputmode="numeric" pattern="[0-9]*"' + ro +
              ' placeholder="—" value="' + chEscape(String(scoreHome)) + '"' +
              ' data-mid="' + chEscape(mid) + '" data-role="home"' +
              ' style="width:56px;height:56px;font-size:26px;font-weight:800;text-align:center;border-radius:14px;background:rgba(255,255,255,.07);border:1.5px solid rgba(255,255,255,.1);color:#fff;outline:none;-moz-appearance:textfield">' +
            '<span style="font-size:20px;font-weight:200;color:rgba(255,255,255,.2)">—</span>' +
            '<input class="sr-ch-score-input" type="number" min="0" max="20" step="1" inputmode="numeric" pattern="[0-9]*"' + ro +
              ' placeholder="—" value="' + chEscape(String(scoreAway)) + '"' +
              ' data-mid="' + chEscape(mid) + '" data-role="away"' +
              ' style="width:56px;height:56px;font-size:26px;font-weight:800;text-align:center;border-radius:14px;background:rgba(255,255,255,.07);border:1.5px solid rgba(255,255,255,.1);color:#fff;outline:none;-moz-appearance:textfield">' +
          '</div>' +
          '<span style="font-size:8px;letter-spacing:3px;color:rgba(155,170,204,.3);font-weight:700">VS</span>' +
        '</div>' +
        // Away team
        '<div style="text-align:center">' +
          '<div style="line-height:1;margin-bottom:10px">' + chBadgeHTML(awayCrest, awayFlag, 46) + '</div>' +
          '<div style="font-size:13px;font-weight:700;color:#F1F5F9;letter-spacing:.2px;line-height:1.3">' + chEscape(awayTeam) + '</div>' +
        '</div>' +
      '</div>' +

      // First scorer
      (!closed ?
        '<div class="sr-ch-first-scorer" data-mid="' + chEscape(mid) + '" style="padding:0 20px 18px">' +
          '<div style="font-size:8px;letter-spacing:2.5px;color:rgba(155,170,204,.4);font-weight:700;text-transform:uppercase;margin-bottom:8px;text-align:center">¿Quién anota primero?</div>' +
          '<div class="sr-ch-first-scorer-btns" style="display:flex;gap:6px">' +
            scorerBtn('home', chEscape(homeTeam), firstScorer === 'home') +
            scorerBtn('none', '0 — 0', firstScorer === 'none') +
            scorerBtn('away', chEscape(awayTeam), firstScorer === 'away') +
          '</div>' +
        '</div>'
        :
        (firstScorer ?
          '<div class="sr-ch-locked-pred" style="padding:2px 20px 16px;font-size:11px;color:rgba(155,170,204,.5);text-align:center">' +
            '⚽ Primer gol: <strong style="color:rgba(155,170,204,.8)">' + (firstScorer === 'home' ? chEscape(homeTeam) : firstScorer === 'away' ? chEscape(awayTeam) : '0 — 0') + '</strong>' +
          '</div>'
          : ''
        )
      ) +

      // Resultado final + puntos ganados en este partido
      (hasRealScore ?
        '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 20px;' +
          'background:rgba(255,255,255,.03);border-top:1px solid rgba(255,255,255,.06)">' +
          '<div>' +
            '<div style="font-size:8px;letter-spacing:2px;color:rgba(155,170,204,.4);font-weight:700;margin-bottom:4px">RESULTADO FINAL</div>' +
            '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:22px;color:#fff">' + realHome + ' — ' + realAway + '</div>' +
          '</div>' +
          (hasPred ?
            '<div style="text-align:right">' +
              '<div style="font-size:8px;letter-spacing:2px;color:rgba(155,170,204,.4);font-weight:700;margin-bottom:4px">PUNTOS DEL PARTIDO</div>' +
              '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:22px;color:' + (basePts > 0 ? '#4ADE80' : '#ef4444') + '">' + (basePts > 0 ? '+' + basePts : '0') + '</div>' +
            '</div>'
            :
            '<div style="font-size:11px;color:rgba(155,170,204,.4);text-align:right;max-width:130px">No hiciste una predicción</div>'
          ) +
        '</div>'
        : ''
      ) +

      // Sponsor band
      (m.sponsorName || m.sponsorLogo ?
        '<div style="padding:14px 20px 18px;background:linear-gradient(135deg,rgba(255,20,100,.08),rgba(155,93,255,.08),rgba(0,207,255,.08));border-top:1px solid rgba(255,255,255,.07);text-align:center">' +
          '<div style="font-size:7px;letter-spacing:3px;color:rgba(155,170,204,.35);font-weight:700;text-transform:uppercase;margin-bottom:10px">PATROCINADO POR</div>' +
          (m.sponsorLogo
            ? '<img src="' + chEscape(m.sponsorLogo) + '" alt="' + chEscape(m.sponsorName || '') + '" style="max-width:85%;height:auto;max-height:120px;object-fit:contain;display:inline-block;filter:brightness(1.1) drop-shadow(0 2px 16px rgba(255,20,100,.25))">'
            : '<div style="font-size:20px;font-weight:800;color:#fff;text-shadow:0 0 20px rgba(255,20,100,.4)">' + chEscape(m.sponsorName) + '</div>'
          ) +
        '</div>'
        : ''
      ) +

      // Footer
      '<div style="display:flex;align-items:center;justify-content:space-between;padding:12px 20px;border-top:1px solid rgba(255,255,255,.05)">' +
        '<div style="display:flex;align-items:center;gap:12px">' +
          '<span class="sr-ch-match-saved" style="font-size:10px;font-weight:600;letter-spacing:.5px;display:' + (hasPred ? 'block' : 'none') + '">✓ Guardado</span>' +
          (hasPred ?
            '<button type="button" class="sr-ch-share-btn" onclick="ChampionsApp.shareMatchPrediction(\'' + chEscape(mid) + '\')" title="Compartir mi predicción">📤 Compartir</button>'
            : ''
          ) +
        '</div>' +
        (!closed ?
          '<button class="sr-ch-btn sr-ch-btn-gold sr-ch-save-btn" data-mid="' + chEscape(mid) + '">' + (hasPred ? 'ACTUALIZAR' : 'GUARDAR') + '</button>'
          :
          '<span style="font-size:10px;color:rgba(155,170,204,.35);letter-spacing:2px;font-weight:700">⏸ CERRADO</span>'
        ) +
      '</div>' +

    '</div>';
  }

  function _attachMatchSave() {
    // Scorer button toggle
    document.querySelectorAll('.sr-ch-scorer-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const mid = btn.dataset.mid;
        document.querySelectorAll('.sr-ch-scorer-btn[data-mid="' + mid + '"]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
    // Save buttons
    document.querySelectorAll('.sr-ch-save-btn').forEach(btn => {
      btn.addEventListener('click', () => savePred(btn.dataset.mid));
    });
    // Scorer toggle en modo Predicción rápida (acotado a la fila, no por mid global)
    document.querySelectorAll('.sr-ch-quick-row').forEach(row => {
      row.querySelectorAll('.sr-ch-qk-scorer-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          row.querySelectorAll('.sr-ch-qk-scorer-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
        });
      });
    });
    // Qualifier team toggle
    document.querySelectorAll('.sr-ch-qual-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const tie = btn.dataset.tie;
        document.querySelectorAll('.sr-ch-qual-btn[data-tie="' + tie + '"]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
    // Qualifier save
    document.querySelectorAll('.sr-ch-qual-save').forEach(btn => {
      btn.addEventListener('click', () => saveQualifier(btn.dataset.tie));
    });
    // Enter on score inputs — only on open cards
    document.querySelectorAll('.sr-ch-score-input').forEach(inp => {
      inp.addEventListener('keydown', e => {
        if (e.key !== 'Enter') return;
        const card = document.getElementById('match-' + inp.dataset.mid);
        if (card && !card.classList.contains('closed')) savePred(inp.dataset.mid);
      });
    });
  }

  /* ── Save prediction ───────────────────────────────── */
  async function savePred(mid) {
    if (!_user || !mid) return;
    const card = document.getElementById('match-' + mid);
    if (!card) return;

    // Revalidar contra el estado REAL y actual del partido antes de escribir — no basta
    // con el atributo "closed" calculado al renderizar la tarjeta: si el usuario dejó la
    // pestaña abierta después de que venció el cierre, o el admin ya cargó el resultado
    // mientras tanto, el DOM queda desactualizado y el botón seguía activo.
    try {
      const freshSnap = await _db.doc('matches/' + mid).get();
      if (freshSnap.exists) {
        const fresh = freshSnap.data();
        const nowClosed = _chIsClosed(fresh);
        if (nowClosed) {
          card.classList.add('closed');
          card.querySelectorAll('.sr-ch-score-input').forEach(inp => inp.setAttribute('readonly', 'readonly'));
          const saveBtnStale = card.querySelector('.sr-ch-save-btn');
          if (saveBtnStale) saveBtnStale.outerHTML = '<span style="font-size:10px;color:rgba(155,170,204,.35);letter-spacing:2px;font-weight:700">⏸ CERRADO</span>';
          chNotif('🔒 El tiempo para predecir este partido ya cerró.', 'error');
          return;
        }
      }
    } catch(e) { /* si la verificación falla por red, no bloquear un guardado legítimo */ }

    const homeInput = card.querySelector('.sr-ch-score-input[data-role="home"]');
    const awayInput = card.querySelector('.sr-ch-score-input[data-role="away"]');
    if (!homeInput || !awayInput) return;

    const homeVal = homeInput.value.trim();
    const awayVal = awayInput.value.trim();
    if (homeVal === '' || awayVal === '') { chNotif('Ingresá los dos marcadores', 'error'); return; }

    const activeScorer = card.querySelector('.sr-ch-scorer-btn.active');
    if (!activeScorer) { chNotif('Seleccioná quién anota primero', 'error'); return; }

    const homeScore = Math.floor(Number(homeVal));
    const awayScore = Math.floor(Number(awayVal));
    if (homeScore < 0 || awayScore < 0 || homeScore > 20 || awayScore > 20) {
      chNotif('Marcador inválido (0–20)', 'error'); return;
    }
    const firstScoringTeam = activeScorer.dataset.val;

    // Validate consistency between score and first scorer
    if (homeScore === 0 && awayScore === 0 && firstScoringTeam !== 'none') {
      chNotif('Si el resultado es 0-0, seleccioná "0 - 0"', 'error'); return;
    }
    if ((homeScore > 0 || awayScore > 0) && firstScoringTeam === 'none') {
      chNotif('Si hay goles, indicá quién anotó primero', 'error'); return;
    }

    const saveBtn = card.querySelector('.sr-ch-save-btn');
    if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = '...'; }

    try {
      await _db.doc('users/' + _user.uid + '/ch_predictions/' + mid).set({
        homeScore, awayScore, firstScoringTeam,
        localScore: homeScore, visitanteScore: awayScore,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        submittedAt: firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true });
      card.classList.add('predicted');
      const saved = card.querySelector('.sr-ch-match-saved');
      if (saved) saved.style.display = 'block';
      // El botón "Compartir" no existía en el HTML inicial si esta era la primera
      // vez que se guardaba (hasPred era false al renderizar la tarjeta) — se
      // agrega recién ahora, sin tener que re-renderizar toda la tarjeta.
      if (saved && !card.querySelector('.sr-ch-share-btn')) {
        const shareBtn = document.createElement('button');
        shareBtn.type = 'button';
        shareBtn.className = 'sr-ch-share-btn';
        shareBtn.title = 'Compartir mi predicción';
        shareBtn.textContent = '📤 Compartir';
        shareBtn.onclick = () => shareMatchPrediction(mid);
        saved.insertAdjacentElement('afterend', shareBtn);
      }
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'ACTUALIZAR'; }
      chNotif('✅ Vaticinio guardado', 'success');
    } catch(err) {
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'GUARDAR'; }
      chNotif('Error al guardar. Intentá de nuevo.', 'error');
    }
  }

  /* ── Compartir predicción (WhatsApp / redes) ──────────
     Mismo patrón ya probado en la Quiniela Mundial: si el navegador soporta el
     share sheet nativo (navigator.share, típico en móvil) lo usamos directo;
     si no, mostramos una tarjeta con el resumen + link de WhatsApp. ── */
  async function shareMatchPrediction(mid) {
    if (!_user || !mid) return;
    try {
      const [matchDoc, predDoc] = await Promise.all([
        _db.doc('matches/' + mid).get(),
        _db.doc('users/' + _user.uid + '/ch_predictions/' + mid).get()
      ]);
      if (!matchDoc.exists || !predDoc.exists) return;
      const m = matchDoc.data();
      const pred = predDoc.data();

      const homeTeam = m.homeTeamName || m.local || 'Por definir';
      const awayTeam = m.awayTeamName || m.visitante || 'Por definir';
      const score = pred.homeScore + '–' + pred.awayScore;
      const scorerTxt = pred.firstScoringTeam === 'home' ? ' (primer gol: ' + homeTeam + ')'
        : pred.firstScoringTeam === 'away' ? ' (primer gol: ' + awayTeam + ')' : '';
      const userName = _profile.displayName || 'Un participante';
      const pageUrl = window.location.href.split('?')[0];
      const shareText = '⚽ ' + userName + ' predice: ' + homeTeam + ' ' + score + ' ' + awayTeam + scorerTxt +
        '\n🏆 Quiniela Champions League 2026/27 — Soccer Revolution' +
        '\n¡Sumate en: ' + pageUrl;

      if (navigator.share) {
        navigator.share({ title: 'Mi predicción ⚽', text: shareText }).catch(() => {});
        return;
      }
      _showSharePredModal(m, pred, shareText);
    } catch(e) {
      chNotif('No se pudo preparar el resumen para compartir', 'error');
    }
  }

  function _showSharePredModal(m, pred, shareText) {
    const existing = document.getElementById('sr-ch-share-pred-modal');
    if (existing) existing.remove();

    const homeTeam = m.homeTeamName || m.local || 'Por definir';
    const awayTeam = m.awayTeamName || m.visitante || 'Por definir';
    const homeFlag = m.homeTeamFlag || m.flagLocal || '⚽';
    const awayFlag = m.awayTeamFlag || m.flagVisitante || '⚽';
    const homeCrest = m.homeTeamCrest || '';
    const awayCrest = m.awayTeamCrest || '';
    const scorerHtml = pred.firstScoringTeam && pred.firstScoringTeam !== 'none'
      ? '<div class="sr-ch-share-card__scorer">⚽ Primer gol: ' + chEscape(pred.firstScoringTeam === 'home' ? homeTeam : awayTeam) + '</div>'
      : '';
    const userName = chEscape(_profile.displayName || '');
    const waText = encodeURIComponent(shareText);

    const overlay = document.createElement('div');
    overlay.id = 'sr-ch-share-pred-modal';
    overlay.className = 'sr-ch-modal-overlay open';
    overlay.innerHTML =
      '<div class="sr-ch-modal" style="max-width:400px;padding:0;overflow:hidden">' +
        '<div class="sr-ch-share-card">' +
          '<div class="sr-ch-share-card__phase">Quiniela Champions 2026/27</div>' +
          '<div class="sr-ch-share-card__teams">' +
            '<div class="sr-ch-share-card__team">' +
              '<span class="sr-ch-share-card__flag">' + chBadgeHTML(homeCrest, homeFlag, 42) + '</span>' +
              '<span class="sr-ch-share-card__name">' + chEscape(homeTeam) + '</span>' +
            '</div>' +
            '<div class="sr-ch-share-card__score">' + pred.homeScore + '<span>—</span>' + pred.awayScore + '</div>' +
            '<div class="sr-ch-share-card__team">' +
              '<span class="sr-ch-share-card__flag">' + chBadgeHTML(awayCrest, awayFlag, 42) + '</span>' +
              '<span class="sr-ch-share-card__name">' + chEscape(awayTeam) + '</span>' +
            '</div>' +
          '</div>' +
          scorerHtml +
          '<div class="sr-ch-share-card__by">' + userName + ' · Soccer Revolution</div>' +
        '</div>' +
        '<div class="sr-ch-share-actions">' +
          '<a href="https://wa.me/?text=' + waText + '" target="_blank" rel="noopener" ' +
            'class="sr-ch-btn sr-ch-btn-primary" style="justify-content:center;text-decoration:none;width:100%">💬 Compartir en WhatsApp</a>' +
          '<button type="button" class="sr-ch-btn" style="justify-content:center;width:100%" onclick="ChampionsApp.closeSharePredModal()">Cerrar</button>' +
        '</div>' +
      '</div>';
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    document.body.appendChild(overlay);
  }

  function closeSharePredModal() {
    const el = document.getElementById('sr-ch-share-pred-modal');
    if (el) el.remove();
  }

  /* ── Save qualifier prediction ─────────────────────── */
  async function saveQualifier(tieId) {
    if (!_user || !tieId) return;
    const activeBtn = document.querySelector('.sr-ch-qual-btn[data-tie="' + tieId + '"].active');
    if (!activeBtn) { chNotif('Seleccioná el equipo que clasifica', 'error'); return; }
    const teamId = activeBtn.dataset.team;
    const saveBtn = document.querySelector('.sr-ch-qual-save[data-tie="' + tieId + '"]');

    // Revalidar contra el estado REAL de la llave antes de escribir — mismo motivo que
    // savePred: el DOM pudo quedar desactualizado si el usuario dejó la pestaña abierta
    // después de que ambos partidos de la llave cerraron o el admin cargó resultados.
    try {
      let legsSnap = await _db.collection('matches').where('tieId', '==', tieId).get();
      if (legsSnap.empty) legsSnap = await _db.collection('matches').where('eliminatoria', '==', tieId).get();
      if (!legsSnap.empty) {
        const legs = [];
        legsSnap.forEach(d => legs.push(d.data()));
        const nowClosed = legs.every(_chIsClosed);
        if (nowClosed) {
          chNotif('🔒 Esta llave ya cerró.', 'error');
          const qualBox = saveBtn ? saveBtn.closest('.sr-ch-qualifier') : null;
          if (qualBox) qualBox.style.display = 'none';
          return;
        }
      }
    } catch(e) { /* si la verificación falla por red, no bloquear un guardado legítimo */ }

    if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = '...'; }
    try {
      await _db.doc('users/' + _user.uid + '/ch_qualifiers/' + tieId).set({
        qualifiedTeamId: teamId,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        submittedAt: firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true });
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'ACTUALIZAR'; }
      chNotif('✅ Clasificado guardado', 'success');
    } catch(err) {
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'GUARDAR CLASIFICADO'; }
      chNotif('Error al guardar. Intentá de nuevo.', 'error');
    }
  }

  /* ── Ranking ───────────────────────────────────────── */
  /* ── Podio Top 3 ───────────────────────────────────── */
  /* ── Duelo: comparación 1 a 1 contra otro participante por nombre de usuario ──
     No hay sistema de amigos — se busca por @usuario cada vez, sin persistir
     nada. Usa el mapa usernames/{lower} (lectura pública) para resolver el uid,
     y ch_profile/main del otro usuario (lectura para cualquier logueado, ver
     reglas de Firestore). ── */
  async function searchDuel() {
    const input = document.getElementById('sr-ch-duel-input');
    const resultEl = document.getElementById('sr-ch-duel-result');
    if (!input || !resultEl || !_user) return;
    const uname = input.value.trim().toLowerCase().replace(/^@/, '');
    if (!uname) return;
    resultEl.innerHTML = '<div style="color:var(--ch-muted);font-size:12px;padding:12px 2px">Buscando...</div>';
    try {
      const unameDoc = await _db.doc('usernames/' + uname).get();
      if (!unameDoc.exists) {
        resultEl.innerHTML = '<div style="color:var(--ch-muted);font-size:12px;padding:12px 2px">No encontramos a ese usuario.</div>';
        return;
      }
      const targetUid = unameDoc.data().uid;
      if (targetUid === _user.uid) {
        resultEl.innerHTML = '<div style="color:var(--ch-muted);font-size:12px;padding:12px 2px">Ese sos vos 😄</div>';
        return;
      }
      const [myProfSnap, theirProfSnap, myUserSnap, theirUserSnap] = await Promise.all([
        _db.doc('users/' + _user.uid + '/ch_profile/main').get(),
        _db.doc('users/' + targetUid + '/ch_profile/main').get(),
        _db.doc('users/' + _user.uid).get(),
        _db.doc('users/' + targetUid).get()
      ]);
      if (!theirProfSnap.exists) {
        resultEl.innerHTML = '<div style="color:var(--ch-muted);font-size:12px;padding:12px 2px">Ese usuario todavía no tiene predicciones.</div>';
        return;
      }
      const me = myProfSnap.exists ? myProfSnap.data() : {};
      const them = theirProfSnap.data();
      const myName = _profile.displayName || (myUserSnap.exists && myUserSnap.data().displayName) || 'Vos';
      const theirName = (theirUserSnap.exists && theirUserSnap.data().displayName) || them.displayName || ('@' + uname);

      const row = (label, a, b) => {
        a = a || 0; b = b || 0;
        return '<div class="sr-ch-duel-row">' +
          '<span class="sr-ch-duel-val' + (a > b ? ' win' : '') + '">' + a + '</span>' +
          '<span class="sr-ch-duel-label">' + label + '</span>' +
          '<span class="sr-ch-duel-val' + (b > a ? ' win' : '') + '">' + b + '</span>' +
        '</div>';
      };

      resultEl.innerHTML =
        '<div class="sr-ch-duel-card">' +
          '<div class="sr-ch-duel-names">' +
            '<span class="sr-ch-duel-name">' + chEscape(myName) + '</span>' +
            '<span class="sr-ch-duel-vs">VS</span>' +
            '<span class="sr-ch-duel-name">' + chEscape(theirName) + '</span>' +
          '</div>' +
          row('Puntos', me.totalPoints, them.totalPoints) +
          row('Aciertos', me.correctos, them.correctos) +
          row('Exactos', me.exactos, them.exactos) +
          row('Racha máx', me.maxStreak, them.maxStreak) +
        '</div>';
    } catch(e) {
      resultEl.innerHTML = '<div style="color:var(--ch-muted);font-size:12px;padding:12px 2px">No se pudo cargar la comparación.</div>';
    }
  }

  function _chPodium(rows) {
    const top3 = rows.slice(0, 3);
    if (top3.length === 0) return '';
    const tiers = [
      { h: 108, medal: '🥇', color: '#FFD65A', glow: 'rgba(255,214,90,.35)' },
      { h: 84,  medal: '🥈', color: '#D8D8E0', glow: 'rgba(216,216,224,.28)' },
      { h: 66,  medal: '🥉', color: '#E3A467', glow: 'rgba(227,164,103,.28)' }
    ];
    // Orden visual: 2do - 1ro - 3ro (el líder queda al centro y más alto)
    const order = [1, 0, 2].filter(i => top3[i]);
    const cols = order.map(i => {
      const r = top3[i], t = tiers[i];
      const initials = (r.displayName || '?').trim().charAt(0).toUpperCase();
      return '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;flex:1;min-width:0">' +
        '<div style="font-size:22px">' + t.medal + '</div>' +
        '<div style="width:52px;height:52px;border-radius:50%;background:rgba(255,255,255,.06);' +
          'border:2px solid ' + t.color + ';display:flex;align-items:center;justify-content:center;' +
          'font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:' + t.color + ';box-shadow:0 0 24px ' + t.glow + ';flex-shrink:0">' +
          chEscape(initials) +
        '</div>' +
        '<div style="font-size:11px;font-weight:700;color:var(--ch-text);text-align:center;max-width:90px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + chEscape(r.displayName) + '</div>' +
        '<div style="width:100%;height:' + t.h + 'px;border-radius:10px 10px 0 0;background:linear-gradient(180deg,' + t.glow + ',transparent);' +
          'border:1px solid ' + t.color + ';border-bottom:none;display:flex;align-items:flex-start;justify-content:center;padding-top:10px;box-sizing:border-box">' +
          '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:' + t.color + '">' + r.totalPoints + '</span>' +
        '</div>' +
      '</div>';
    }).join('');
    return '<div style="display:flex;align-items:flex-end;gap:10px;margin-bottom:22px;padding:0 4px">' + cols + '</div>';
  }

  // Premio semanal: quien más puntos suma en cada jornada de liga se gana una
  // camisola. "decided" (calculado por el admin en cada recálculo de puntos)
  // marca si esa jornada ya jugó todos sus partidos — si no, es un líder
  // provisorio ("en juego"), no todavía el ganador confirmado.
  function _renderJornadaWinners(jornadas) {
    if (!jornadas || Object.keys(jornadas).length === 0) return '';
    const nums = Object.keys(jornadas).map(n => parseInt(n, 10)).sort((a, b) => a - b);
    const cards = nums.map(n => {
      const w = jornadas[String(n)];
      const decided = !!w.decided;
      return '<div style="flex:0 0 auto;min-width:118px;background:' + (decided ? 'rgba(255,20,100,.06)' : 'rgba(255,255,255,.03)') + ';' +
        'border:1px solid ' + (decided ? 'rgba(255,20,100,.25)' : 'rgba(255,255,255,.08)') + ';border-radius:12px;padding:10px 12px;text-align:center">' +
        '<div style="font-size:9px;letter-spacing:1.5px;color:var(--ch-muted);font-weight:700;margin-bottom:6px">JORNADA ' + n + '</div>' +
        '<div style="font-size:20px;line-height:1;margin-bottom:4px">' + (decided ? '👕' : '⏳') + '</div>' +
        '<div style="font-size:11px;font-weight:700;color:var(--ch-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100px;margin:0 auto">' + chEscape(w.name) + '</div>' +
        '<div style="font-size:10px;color:var(--ch-gold);font-weight:700;margin-top:2px">' + w.pts + ' pts</div>' +
        (decided
          ? '<div style="font-size:8px;letter-spacing:1px;color:#4ade80;font-weight:700;margin-top:4px">GANADOR</div>'
          : '<div style="font-size:8px;letter-spacing:1px;color:#f59e0b;font-weight:700;margin-top:4px">EN JUEGO</div>'
        ) +
      '</div>';
    }).join('');

    return '<div style="margin-bottom:20px">' +
      '<div style="font-size:11px;letter-spacing:2px;color:var(--ch-gold);font-weight:700;margin-bottom:10px">👕 GANADOR DE LA JORNADA</div>' +
      '<div style="font-size:11px;color:var(--ch-muted);margin-bottom:10px">El que más puntos suma en cada jornada de liga se gana una camisola.</div>' +
      '<div style="display:flex;gap:8px;overflow-x:auto;padding-bottom:4px;-webkit-overflow-scrolling:touch">' + cards + '</div>' +
    '</div>';
  }

  async function _renderRanking() {
    const cont = document.getElementById('sr-ch-ranking-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:30px;font-size:13px">Cargando...</div>';
    try {
      const [rows0, jwSnap] = await Promise.all([
        _chGetAllProfiles(),
        _db.doc('config/jornadaWinners').get().catch(() => null)
      ]);
      const rows = rows0.slice();
      const jornadaWinnersHTML = _renderJornadaWinners(jwSnap && jwSnap.exists ? jwSnap.data().jornadas : null);
      // Desempate determinístico: sin esto, dos participantes con los mismos puntos
      // quedaban en un orden distinto en cada recarga (dependía del orden de llegada
      // de las promesas de Firestore) — el #4 y el #5 podían "intercambiarse" sin
      // ningún cambio real. Ahora desempata por aciertos y luego por nombre, así el
      // orden es siempre el mismo para los mismos datos.
      rows.sort((a, b) =>
        b.totalPoints - a.totalPoints ||
        b.correctos   - a.correctos   ||
        a.displayName.localeCompare(b.displayName)
      );

      if (rows.length === 0) {
        cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:30px;font-size:13px">Aún no hay participantes registrados.</div>';
        return;
      }

      const myIdx = rows.findIndex(r => r.uid === _user.uid);
      let html = _chPodium(rows);
      html += jornadaWinnersHTML;

      // Resumen "tu posición" + brecha con el de arriba + acceso rápido a tu fila
      if (myIdx >= 0) {
        const myPos = myIdx + 1;
        let gapHtml;
        if (myIdx === 0) {
          gapHtml = rows.length > 1 ? '¡Estás liderando! 🏆' : 'Sos el único participante por ahora.';
        } else {
          const above = rows[myIdx - 1];
          const gap = above.totalPoints - rows[myIdx].totalPoints;
          gapHtml = gap > 0
            ? 'A <strong style="color:var(--ch-gold)">' + gap + ' pts</strong> de superar a <strong>' + chEscape(above.displayName) + '</strong> (#' + (myPos - 1) + ')'
            : 'Empatado en puntos con <strong>' + chEscape(above.displayName) + '</strong>';
        }
        html += '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;' +
          'margin-bottom:16px;padding:12px 16px;background:rgba(255,20,100,.05);border:1px solid rgba(255,20,100,.15);border-radius:12px">' +
          '<div style="font-size:12px;color:var(--ch-text2)">Estás en <strong style="color:var(--ch-gold)">#' + myPos + '</strong> de ' + rows.length + ' &nbsp;·&nbsp; ' + gapHtml + '</div>' +
          '<button type="button" class="sr-ch-btn" onclick="ChampionsApp.scrollToMyRank()" style="font-size:11px;padding:7px 14px;white-space:nowrap">📍 VER MI POSICIÓN</button>' +
        '</div>';
      }

      html += '<table class="sr-ch-rank-table"><thead><tr>' +
        '<th>#</th><th>Participante</th><th>Nivel</th><th>🔥</th><th>Pts</th>' +
        '</tr></thead><tbody>';
      const activeLevels = _chActiveLevels();
      rows.forEach((r, i) => {
        const pos = i + 1;
        const isMe = r.uid === _user.uid;
        const lvl  = chGetLevel(r.totalPoints, activeLevels);
        const pc   = pos === 1 ? 'p1' : pos === 2 ? 'p2' : pos === 3 ? 'p3' : '';
        html += '<tr class="sr-ch-rank-row' + (isMe ? ' me' : '') + '"' + (isMe ? ' id="sr-ch-rank-me-row"' : '') + '>' +
          '<td><span class="sr-ch-rank-pos ' + pc + '">' +
            (pos === 1 ? '🥇' : pos === 2 ? '🥈' : pos === 3 ? '🥉' : pos) +
          '</span></td>' +
          '<td class="sr-ch-rank-name">' + chEscape(r.displayName) + (isMe ? ' <span style="color:var(--ch-muted);font-size:11px">(tú)</span>' : '') + '</td>' +
          '<td>' + (lvl ? '<span class="sr-ch-level-chip">' + lvl.icon + '</span>' : '<span style="color:var(--ch-muted)">—</span>') + '</td>' +
          '<td>' + (r.maxStreak >= 3 ? '<span style="font-size:11px;font-weight:700;color:#f59e0b" title="Mejor racha: ' + r.maxStreak + ' aciertos seguidos">' + r.maxStreak + '</span>' : '<span style="color:var(--ch-muted)">—</span>') + '</td>' +
          '<td class="sr-ch-rank-pts">' + r.totalPoints + '</td>' +
        '</tr>';
      });
      html += '</tbody></table>';
      cont.innerHTML = html;
    } catch(err) {
      cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:30px;font-size:13px">Error al cargar. Intentá de nuevo.</div>';
    }
    renderSponsorStrip();
  }

  function scrollToMyRank() {
    const row = document.getElementById('sr-ch-rank-me-row');
    if (!row) return;
    row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    row.style.transition = 'box-shadow .4s ease';
    row.style.boxShadow  = 'inset 0 0 0 2px rgba(255,20,100,.6)';
    setTimeout(() => { row.style.boxShadow = ''; }, 1800);
  }

  /* ── Premios ───────────────────────────────────────── */
  function _renderPremios() {
    const cont = document.getElementById('sr-ch-premios-content');
    if (!cont) return;

    const pts   = _profile.totalPoints || 0;
    const extra = _premios.textoExtra || '';

    // Use Firestore prizes if available, otherwise fall back to hardcoded data
    const prizes = _prizesData.length > 0
      ? _prizesData.slice().reverse()
      : CH_DATA.termometro.slice().reverse().map(t => ({ pts: t.pts, title: t.label, icon: t.icon }));

    // Resumen de progreso — mismo espíritu que el termómetro del Dashboard, pero
    // enfocado en "qué sigue" para esta pantalla específica.
    let html = '';
    const ascPrizes = prizes.slice().reverse(); // de menor a mayor pts
    const nextPrize = ascPrizes.find(p => pts < (p.pts || 0));
    if (nextPrize) {
      const gap = (nextPrize.pts || 0) - pts;
      const maxPts = ascPrizes[ascPrizes.length - 1].pts || 1;
      const pct = Math.min((pts / maxPts) * 100, 100);
      html += '<div style="margin-bottom:18px;padding:14px 18px;background:rgba(255,20,100,.05);border:1px solid rgba(255,20,100,.15);border-radius:12px">' +
        '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:8px;flex-wrap:wrap;gap:6px">' +
          '<span style="font-size:12px;color:var(--ch-text2)">Tenés <strong style="color:var(--ch-gold);font-family:\'Bebas Neue\',sans-serif;font-size:16px">' + pts + '</strong> pts</span>' +
          '<span style="font-size:12px;color:var(--ch-text2)">Te faltan <strong style="color:var(--ch-gold)">' + gap + ' pts</strong> para ' + chEscape(nextPrize.icon || '🏆') + ' ' + chEscape(nextPrize.title || '') + '</span>' +
        '</div>' +
        '<div style="height:6px;background:var(--ch-raised);border-radius:4px;overflow:hidden">' +
          '<div style="height:100%;width:' + pct + '%;background:linear-gradient(90deg,#FF1464,#9B5DFF);border-radius:4px;transition:width .8s cubic-bezier(0.22,1,0.36,1)"></div>' +
        '</div>' +
      '</div>';
    } else if (ascPrizes.length > 0) {
      html += '<div style="margin-bottom:18px;padding:14px 18px;background:rgba(34,197,94,.06);border:1px solid rgba(34,197,94,.2);border-radius:12px;text-align:center;font-size:13px;color:#4ade80;font-weight:700">' +
        '🎉 ¡Alcanzaste el nivel máximo! Tenés ' + pts + ' pts.' +
      '</div>';
    }

    prizes.forEach((p, i) => {
      const reached = pts >= p.pts;
      const hasSponsor = !!(p.sponsorName || p.sponsorLogo);
      const gapToThis = (p.pts || 0) - pts;
      html += '<div class="sr-ch-prize"' +
        (reached ? ' style="border-color:rgba(255,20,100,.3);background:rgba(255,20,100,.05)"' : '') +
        '>' +
        '<div class="sr-ch-prize-icon">' + chEscape(p.icon || '🏆') + '</div>' +
        '<div style="flex:1;min-width:0">' +
          '<div class="sr-ch-prize-nivel" style="' + (reached ? 'color:#FF1464' : '') + '">' + (reached ? '✅ DESBLOQUEADO' : 'NIVEL ' + (prizes.length - i)) + '</div>' +
          '<div class="sr-ch-prize-label">' + chEscape(p.title || '') + '</div>' +
          '<div class="sr-ch-prize-desc">' +
            (reached
              ? 'Alcanzado con ' + (p.pts || 0) + ' puntos.'
              : 'Al acumular ' + (p.pts || 0) + ' puntos · <strong style="color:var(--ch-gold)">te faltan ' + gapToThis + ' pts</strong>') +
          '</div>' +
          (hasSponsor ?
            '<div style="display:flex;align-items:center;gap:6px;margin-top:6px">' +
              '<span style="font-size:7px;letter-spacing:2px;color:rgba(155,170,204,.4);font-weight:700">PATROCINADO POR</span>' +
              (p.sponsorUrl ? '<a href="' + chEscape(p.sponsorUrl) + '" target="_blank" rel="noopener" onclick="ChampionsApp.sponsorClick(null,\'' + chEscape(p.id || '') + '\')" style="text-decoration:none">' : '') +
              (p.sponsorLogo
                ? '<img src="' + chEscape(p.sponsorLogo) + '" alt="' + chEscape(p.sponsorName || '') + '" style="height:20px;max-width:90px;object-fit:contain;vertical-align:middle">'
                : '<span style="font-size:11px;font-weight:700;color:rgba(255,255,255,.6)">' + chEscape(p.sponsorName || '') + '</span>'
              ) +
              (p.sponsorUrl ? '</a>' : '') +
            '</div>'
            : ''
          ) +
        '</div>' +
        '<div class="sr-ch-prize-pts">' + (p.pts || 0) + '<small>pts</small></div>' +
      '</div>';
    });

    if (extra) {
      html += '<div class="sr-ch-panel" style="margin-top:20px"><div style="font-size:14px;color:var(--ch-text2);line-height:1.7">' + chEscape(extra) + '</div></div>';
    }

    if (!_premios.condiciones) {
      html += '<div class="sr-ch-panel" style="margin-top:20px;background:rgba(255,20,100,0.05);border-color:rgba(255,20,100,0.2)">' +
        '<div class="sr-ch-panel-title">📋 CONDICIONES</div>' +
        '<ul style="list-style:none;display:flex;flex-direction:column;gap:10px">' +
        '<li style="font-size:13px;color:var(--ch-text2)">• Los premios se entregan al alcanzar los puntos requeridos.</li>' +
        '<li style="font-size:13px;color:var(--ch-text2)">• Los puntos se acumulan durante toda la temporada Champions 2026/27.</li>' +
        '</ul>' +
      '</div>';
    } else {
      html += '<div class="sr-ch-panel" style="margin-top:20px;background:rgba(255,20,100,0.05);border-color:rgba(255,20,100,0.2)">' +
        '<div class="sr-ch-panel-title">📋 CONDICIONES</div>' +
        '<div style="font-size:13px;color:var(--ch-text2);line-height:1.7;white-space:pre-wrap">' + chEscape(_premios.condiciones) + '</div>' +
      '</div>';
    }

    cont.innerHTML = html;
    renderSponsorTitle();
    renderSponsorStrip();
  }

  /* ── Cómo funciona ─────────────────────────────────── */
  function _renderComoFunciona() {
    const cont = document.getElementById('sr-ch-como-content');
    if (!cont) return;

    const nLevels = _prizesData.length || 5;
    const prizeDesc = _prizesData.length > 0
      ? _prizesData.map(p => (p.icon ? p.icon + ' ' : '') + (p.title || '') + ' (' + (p.pts || 0) + ' pts)').join(' · ')
      : 'Revisá la pantalla de Premios para ver los niveles disponibles esta temporada.';
    const steps = [
      { icon:'📝', title:'Registrate y entrá', desc:'Creá tu cuenta con correo y contraseña. Tus puntos quedan guardados permanentemente durante toda la temporada.' },
      { icon:'🔮', title:'Vaticiná los partidos', desc:'Ingresá el marcador antes del cierre. Fase de Liga: 8 jornadas (~18 partidos cada una). Eliminatorias: predecís ida y vuelta por separado, más quién clasifica.' },
      { icon:'⭐', title:'Ganás puntos', desc:'Resultado correcto: 2–22 pts según la fase. Marcador exacto: 7–60 pts extra. Anotador: 2–10 pts extra. Las rachas de aciertos consecutivos suman bonus aparte.' },
      { icon:'🌡️', title:'Subí en el termómetro', desc:'Cada punto acumulado te acerca al siguiente nivel. Hay ' + nLevels + ' niveles de premio a lo largo de toda la temporada, y quedan desbloqueados para siempre.' },
      { icon:'🎁', title:'Canjeá tus premios', desc: prizeDesc }
    ];

    // Tira visual de flujo — resumen de un vistazo antes del detalle paso a paso
    let html = '<div class="sr-ch-panel" style="overflow-x:auto">' +
      '<div style="display:flex;align-items:flex-start;gap:2px;min-width:460px">' +
      steps.map((s, i) =>
        '<div style="display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;min-width:0">' +
          '<div style="width:42px;height:42px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:19px;' +
            'background:rgba(255,20,100,.08);border:1.5px solid rgba(255,20,100,.3);flex-shrink:0">' + s.icon + '</div>' +
          '<span style="font-size:8.5px;letter-spacing:.3px;color:var(--ch-text2);text-align:center;font-weight:700;text-transform:uppercase;line-height:1.3">' + chEscape(s.title.split(' ').slice(0,2).join(' ')) + '</span>' +
        '</div>' +
        (i < steps.length - 1 ? '<div style="color:rgba(255,20,100,.35);font-size:14px;flex-shrink:0;padding-top:10px">→</div>' : '')
      ).join('') +
      '</div>' +
    '</div>';

    html += '<div class="sr-ch-panel">';
    steps.forEach(s => {
      html += '<div class="sr-ch-step">' +
        '<div class="sr-ch-step-num" style="font-size:14px">' + s.icon + '</div>' +
        '<div><div class="sr-ch-step-title">' + chEscape(s.title) + '</div>' +
        '<div class="sr-ch-step-desc">' + chEscape(s.desc) + '</div></div>' +
      '</div>';
    });
    html += '</div>';

    // Tabla de puntos con CSS grid
    html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">⭐ SISTEMA DE PUNTOS</div>' +
      '<div style="overflow-x:auto"><div class="sr-ch-pts-grid">' +
      '<div class="sr-ch-pts-grid-head">Fase</div>' +
      '<div class="sr-ch-pts-grid-head">Resultado</div>' +
      '<div class="sr-ch-pts-grid-head">Exacto</div>' +
      '<div class="sr-ch-pts-grid-head">Anotador</div>';
    CH_DATA.fases.forEach(f => {
      html += '<div class="sr-ch-pts-row">' +
        '<div>' + chEscape(f.nombre) + '</div>' +
        '<div>' + f.puntos.resultado + '</div>' +
        '<div>' + f.puntos.exacto + '</div>' +
        '<div>' + f.puntos.anotador + '</div>' +
      '</div>';
    });
    html += '</div></div>' +
      '<div style="margin-top:14px;padding:11px 14px;background:rgba(0,207,255,.06);border:1px solid rgba(0,207,255,.2);border-radius:10px;font-size:12px;color:var(--ch-text2);line-height:1.6">' +
        '<strong style="color:#00CFFF">💡 ¿Qué es "Anotador"?</strong> Es el <strong>EQUIPO</strong> que mete el primer gol del partido — no un jugador en particular. En cada partido elegís entre el equipo local, el visitante, o "Sin goles" si creés que va a terminar 0-0.' +
      '</div>' +
    '</div>';

    // Rachas — con ejemplo concreto, no solo la tabla de números
    html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">🔥 BONOS DE RACHA</div>' +
      '<div style="font-size:12.5px;color:var(--ch-text2);line-height:1.7;margin-bottom:14px">' +
        'Cada vez que acertás el <strong>resultado</strong> de un partido (no hace falta el marcador exacto) tu racha sube un acierto más. Si fallás uno, la racha vuelve a cero. ' +
        '<strong style="color:var(--ch-gold)">Ejemplo:</strong> si acertás 3 partidos seguidos, además de los puntos de cada uno ganás un bono extra de +5 pts en ese tercer acierto.' +
      '</div>';
    CH_DATA.rachas.forEach(r => {
      html += '<div style="display:flex;justify-content:space-between;align-items:center;padding:11px 0;border-bottom:1px solid rgba(255,255,255,.03)">' +
        '<span style="font-size:12px;color:var(--ch-muted)">' + r.n + ' aciertos consecutivos</span>' +
        '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;color:var(--ch-gold)">+' + r.bonus + ' pts</span>' +
      '</div>';
    });
    html += '</div>';

    // Preguntas frecuentes
    const faqs = [
      { q: '¿Qué pasa si no predigo un partido?', a: 'No ganás ni perdés puntos por ese partido en particular, pero tu racha de aciertos se corta, igual que si hubieras fallado.' },
      { q: '¿Puedo cambiar mi predicción después de guardarla?', a: 'Sí, las veces que quieras, siempre que el partido todavía no haya cerrado — fijate en la cuenta regresiva de cada tarjeta.' },
      { q: '¿Cómo se decide quién "clasifica" en las eliminatorias?', a: 'Lo elegís aparte, directamente ("¿Quién clasifica a la siguiente ronda?") — no se calcula a partir de tus marcadores de ida y vuelta. No hace falta predecir penales ni tiempo extra.' },
      { q: '¿Qué pasa si empato en puntos con otro participante en el ranking?', a: 'Se desempata primero por cantidad de aciertos y, si sigue habiendo empate, por orden alfabético del nombre — así el orden es siempre el mismo.' },
      { q: '¿Los niveles de premio se van acumulando?', a: 'Sí: cada nivel que alcanzás queda desbloqueado para siempre durante la temporada, aunque sigas sumando puntos hacia el siguiente.' }
    ];
    html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">❓ PREGUNTAS FRECUENTES</div>';
    faqs.forEach((f, i) => {
      html += '<div style="padding:12px 0;' + (i < faqs.length - 1 ? 'border-bottom:1px solid rgba(255,255,255,.04);' : '') + '">' +
        '<div style="font-size:13px;font-weight:700;color:var(--ch-text);margin-bottom:5px">' + chEscape(f.q) + '</div>' +
        '<div style="font-size:12.5px;color:var(--ch-text2);line-height:1.6">' + chEscape(f.a) + '</div>' +
      '</div>';
    });
    html += '</div>';

    cont.innerHTML = html;
  }

  /* ── Chart Helpers ────────────────────────────────── */
  function _svgDonut(pct, color, size, stroke) {
    const r    = (size - stroke) / 2;
    const circ = parseFloat((2 * Math.PI * r).toFixed(3));
    const off  = parseFloat((circ * (1 - pct / 100)).toFixed(3));
    const c    = size / 2;
    const gid  = 'dg' + Math.random().toString(36).slice(2,6);
    const fs   = Math.round(size * 0.22);  // font size proporcional
    return '<svg width="100%" height="100%" viewBox="0 0 ' + size + ' ' + size + '" style="display:block">' +
      '<defs>' +
        '<linearGradient id="' + gid + '" x1="0%" y1="0%" x2="100%" y2="0%">' +
          '<stop offset="0%" stop-color="#FF1464"/>' +
          '<stop offset="50%" stop-color="#9B5DFF"/>' +
          '<stop offset="100%" stop-color="#00CFFF"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<circle cx="' + c + '" cy="' + c + '" r="' + r + '" fill="none" stroke="rgba(255,255,255,.10)" stroke-width="' + stroke + '"/>' +
      '<circle class="sr-ch-donut-arc" cx="' + c + '" cy="' + c + '" r="' + r + '" fill="none" stroke="url(#' + gid + ')" stroke-width="' + stroke + '"' +
        ' stroke-dasharray="' + circ + '" stroke-dashoffset="' + circ + '"' +
        ' stroke-linecap="round" transform="rotate(-90 ' + c + ' ' + c + ')"' +
        ' data-target="' + off + '"' +
        ' style="transition:stroke-dashoffset 1.1s cubic-bezier(0.22,1,0.36,1)"/>' +
      '<text x="' + c + '" y="' + (c - fs * 0.15) + '" text-anchor="middle" dominant-baseline="middle"' +
        ' fill="' + color + '" font-family="\'Bebas Neue\',sans-serif" font-size="' + fs + '" font-weight="700">' + pct + '%</text>' +
      '<text x="' + c + '" y="' + (c + fs * 0.72) + '" text-anchor="middle" dominant-baseline="middle"' +
        ' fill="rgba(155,170,204,.6)" font-family="DM Sans,sans-serif" font-size="' + Math.round(size * 0.065) + '" letter-spacing="2" font-weight="700">ACIERTOS</text>' +
    '</svg>';
  }

  function _drawRadarChart(canvasId, dims) {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const cw = canvas.clientWidth || 220, ch = canvas.clientHeight || 220;
    canvas.width = cw * dpr; canvas.height = ch * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    const cx = cw / 2, cy = ch / 2, maxR = Math.min(cx, cy) * 0.60;
    const n = dims.length, step = (Math.PI * 2) / n;
    for (let ring = 1; ring <= 4; ring++) {
      ctx.beginPath();
      for (let i = 0; i < n; i++) {
        const a = step * i - Math.PI / 2, r = maxR * ring / 4;
        i === 0 ? ctx.moveTo(cx+Math.cos(a)*r, cy+Math.sin(a)*r) : ctx.lineTo(cx+Math.cos(a)*r, cy+Math.sin(a)*r);
      }
      ctx.closePath();
      ctx.strokeStyle = ring === 4 ? 'rgba(255,255,255,.12)' : 'rgba(255,255,255,.05)';
      ctx.lineWidth = 1; ctx.stroke();
    }
    for (let i = 0; i < n; i++) {
      const a = step * i - Math.PI / 2;
      ctx.beginPath(); ctx.moveTo(cx, cy);
      ctx.lineTo(cx+Math.cos(a)*maxR, cy+Math.sin(a)*maxR);
      ctx.strokeStyle = 'rgba(255,255,255,.08)'; ctx.lineWidth = 1; ctx.stroke();
    }
    ctx.beginPath();
    for (let i = 0; i < n; i++) {
      const a = step * i - Math.PI / 2, r = maxR * Math.min(dims[i].val, 100) / 100;
      i === 0 ? ctx.moveTo(cx+Math.cos(a)*r, cy+Math.sin(a)*r) : ctx.lineTo(cx+Math.cos(a)*r, cy+Math.sin(a)*r);
    }
    ctx.closePath(); ctx.fillStyle = 'rgba(255,20,100,.12)'; ctx.fill();
    var radarGrad = ctx.createLinearGradient(cx - maxR, cy, cx + maxR, cy);
    radarGrad.addColorStop(0, '#FF1464'); radarGrad.addColorStop(.5, '#9B5DFF'); radarGrad.addColorStop(1, '#00CFFF');
    ctx.strokeStyle = radarGrad; ctx.lineWidth = 2; ctx.stroke();
    var dotColors = ['#FF1464','#9B5DFF','#00CFFF','#A8FF00','#FF1464','#9B5DFF'];
    for (let i = 0; i < n; i++) {
      const a = step * i - Math.PI / 2, r = maxR * Math.min(dims[i].val, 100) / 100;
      ctx.beginPath(); ctx.arc(cx+Math.cos(a)*r, cy+Math.sin(a)*r, 3.5, 0, Math.PI*2);
      ctx.fillStyle = dotColors[i % dotColors.length]; ctx.fill();
    }
    for (let i = 0; i < n; i++) {
      const a = step * i - Math.PI / 2;
      const labelR = maxR + Math.max(18, Math.min(cx, cy) * 0.18);
      const lx = cx + Math.cos(a) * labelR, ly = cy + Math.sin(a) * labelR;
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillStyle = '#aab4cc'; ctx.font = '500 9.5px "DM Sans",sans-serif';
      ctx.fillText(dims[i].label, lx, ly - 7);
      ctx.fillStyle = dotColors[i % dotColors.length]; ctx.font = '700 9px "DM Sans",sans-serif';
      ctx.fillText(Math.round(dims[i].val) + '%', lx, ly + 7);
    }
  }

  function _drawLineChart(canvasId, history) {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const dw = canvas.clientWidth, dh = canvas.clientHeight;
    canvas.width = dw * dpr; canvas.height = dh * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    const pad = { t:18, r:16, b:28, l:46 };
    const cw = dw - pad.l - pad.r, ch = dh - pad.t - pad.b;
    if (!history || history.length === 0) {
      ctx.fillStyle = '#536080'; ctx.font = '12px "DM Sans",sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Sin partidos jugados aún', dw/2, dh/2); return;
    }
    const maxPts = Math.max(...history, 1);
    ctx.font = '10px "DM Sans",sans-serif'; ctx.fillStyle = '#536080'; ctx.textAlign = 'right';
    for (let i = 0; i <= 4; i++) {
      const val = Math.round(maxPts * i / 4), y = pad.t + ch - (i / 4) * ch;
      ctx.fillText(val, pad.l - 8, y + 3);
      if (i > 0) {
        ctx.beginPath(); ctx.moveTo(pad.l, y); ctx.lineTo(pad.l + cw, y);
        ctx.strokeStyle = 'rgba(255,255,255,.04)'; ctx.lineWidth = 1; ctx.stroke();
      }
    }
    const pts = history.map((v, i) => ({
      x: pad.l + (history.length === 1 ? cw/2 : (i/(history.length-1))*cw),
      y: pad.t + ch - (v / maxPts) * ch
    }));
    const grad = ctx.createLinearGradient(0, pad.t, 0, pad.t + ch);
    grad.addColorStop(0, 'rgba(155,93,255,.5)');
    grad.addColorStop(.5, 'rgba(255,20,100,.2)');
    grad.addColorStop(1, 'rgba(255,20,100,.02)');
    ctx.beginPath();
    ctx.moveTo(pts[0].x, pad.t + ch);
    pts.forEach(p => ctx.lineTo(p.x, p.y));
    ctx.lineTo(pts[pts.length-1].x, pad.t + ch);
    ctx.closePath(); ctx.fillStyle = grad; ctx.fill();
    ctx.beginPath();
    pts.forEach((p,i) => i === 0 ? ctx.moveTo(p.x,p.y) : ctx.lineTo(p.x,p.y));
    var lineGrad = ctx.createLinearGradient(pad.l, 0, pad.l + cw, 0);
    lineGrad.addColorStop(0, '#FF1464'); lineGrad.addColorStop(.5, '#9B5DFF'); lineGrad.addColorStop(1, '#00CFFF');
    ctx.strokeStyle = lineGrad; ctx.lineWidth = 2; ctx.lineJoin = 'round'; ctx.stroke();
    const tickStep = Math.max(1, Math.floor(history.length / 8));
    pts.forEach((p, i) => {
      if (i % tickStep === 0) {
        ctx.beginPath(); ctx.arc(p.x, p.y, 2.5, 0, Math.PI*2);
        ctx.fillStyle = '#9B5DFF'; ctx.fill();
      }
    });
    const last = pts[pts.length-1];
    ctx.beginPath(); ctx.arc(last.x, last.y, 5, 0, Math.PI*2);
    ctx.fillStyle = '#00CFFF'; ctx.fill();
    ctx.strokeStyle = '#080b12'; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = '#00CFFF'; ctx.font = '700 11px "DM Sans",sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
    ctx.fillText(history[history.length-1], last.x, last.y - 9);
  }

  /* ── Mis Stats ─────────────────────────────────────── */
  /* ── Carta de Jugador (estilo FIFA/FUT) ──────────────── */
  function _chPlayerCard(displayName, pos, totalUsers, total, pre, exa, gol, rac, gru, nivelInfo) {
    const initials = (displayName || 'Jugador').trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';

    if (total === 0) {
      return '<div class="sr-ch-panel sr-ch-pcard" style="display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'gap:10px;border-style:dashed;padding:36px 20px;text-align:center">' +
        '<div style="font-size:34px;opacity:0.5">🃏</div>' +
        '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;letter-spacing:1.5px;color:var(--ch-text2)">TU CARTA SE ESTÁ FORJANDO</div>' +
        '<div style="font-size:12px;color:var(--ch-muted);max-width:280px">Se revelará tu rating en cuanto termine el primer partido con resultado.</div>' +
      '</div>';
    }

    const av = v => Math.round(Math.max(Math.min(v, 100), 0));
    const P = av(pre), E = av(exa), G = av(gol), R = av(rac), U = av(gru);
    const ovr = Math.round(P * 0.40 + E * 0.25 + G * 0.15 + R * 0.10 + U * 0.10);

    const tiers = [
      { min: 85, name: 'ÉLITE',  grad: 'linear-gradient(135deg,#050505 0%,#0e2440 24%,#00CFFF 42%,#9B5DFF 58%,#FF1464 76%,#050505 100%)',
        border: '#fff', ink: '#fff', sub: 'rgba(255,255,255,0.78)', holo: true },
      { min: 75, name: 'ORO',    grad: 'linear-gradient(150deg,#4a0022 0%,#FF1464 55%,#ff8ab8 100%)', border: '#ffb8d4', ink: '#fff', sub: 'rgba(255,255,255,0.72)' },
      { min: 60, name: 'PLATA',  grad: 'linear-gradient(150deg,#4a4a52 0%,#a8a8b2 55%,#e8e8ee 100%)', border: '#e8e8ee', ink: '#1a1a1a', sub: 'rgba(26,26,26,0.6)' },
      { min: 0,  name: 'BRONCE', grad: 'linear-gradient(150deg,#3a2410 0%,#8a5a2e 55%,#cd9a5c 100%)', border: '#cd9a5c', ink: '#241608', sub: 'rgba(36,22,8,0.6)' }
    ];
    const tier = tiers.find(t => ovr >= t.min);

    const arche = [
      { v: P, label: 'EL CONSISTENTE',   icon: '🧠' },
      { v: E, label: 'EL FRANCOTIRADOR', icon: '🎯' },
      { v: G, label: 'EL VIDENTE',       icon: '🔮' },
      { v: R, label: 'EL HOT STREAK',    icon: '🔥' },
      { v: U, label: 'EL LÍDER',         icon: '👑' }
    ].sort((a, b) => b.v - a.v)[0];

    const attr = (label, val) =>
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;padding:5px 0">' +
        '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:16px;color:' + tier.ink + ';min-width:26px">' + val + '</span>' +
        '<span style="font-size:9.5px;letter-spacing:1.2px;color:' + tier.sub + ';font-weight:700">' + label + '</span>' +
      '</div>';

    const holoStyle = tier.holo ? 'background-size:220% 220%;animation:sr-ch-holo 5s ease infinite;' : '';

    return '<div class="sr-ch-panel sr-ch-pcard" style="position:relative;overflow:hidden;background:' + tier.grad + ';' +
      'border:1px solid ' + tier.border + ';box-shadow:0 10px 34px rgba(0,0,0,0.55),inset 0 1px 0 rgba(255,255,255,0.25);' + holoStyle + '">' +
      '<div style="display:flex;gap:18px;align-items:stretch;flex-wrap:wrap">' +
        '<div style="display:flex;flex-direction:column;align-items:center;min-width:86px">' +
          '<div id="ch-pcard-ovr" data-num="' + ovr + '" style="font-family:\'Bebas Neue\',sans-serif;font-size:52px;line-height:0.9;color:' + tier.ink + '">0</div>' +
          '<div style="font-size:10px;letter-spacing:2.5px;font-weight:800;color:' + tier.ink + ';opacity:0.85;margin-top:2px">' + tier.name + '</div>' +
          '<div style="width:56px;height:56px;border-radius:50%;background:rgba(0,0,0,0.22);border:2px solid ' + tier.ink + ';' +
            'display:flex;align-items:center;justify-content:center;margin-top:10px;font-family:\'Bebas Neue\',sans-serif;font-size:20px;color:' + tier.ink + '">' +
            chEscape(initials) +
          '</div>' +
        '</div>' +
        '<div style="flex:1;min-width:150px;display:grid;grid-template-columns:1fr 1fr;gap:0 14px;' +
          'border-left:1px solid rgba(0,0,0,0.2);border-right:1px solid rgba(0,0,0,0.2);padding:0 16px">' +
          '<div>' + attr('PRE', P) + attr('EXA', E) + attr('GOL', G) + '</div>' +
          '<div>' + attr('RAC', R) + attr('GRU', U) + '</div>' +
        '</div>' +
        '<div style="min-width:130px;display:flex;flex-direction:column;justify-content:center;gap:4px">' +
          '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:19px;color:' + tier.ink + ';line-height:1.05;word-break:break-word">' + chEscape(displayName || 'Jugador') + '</div>' +
          '<div style="font-size:10.5px;color:' + tier.sub + ';font-weight:700">' + arche.icon + ' ' + arche.label + '</div>' +
          (nivelInfo ? '<div style="font-size:10px;color:' + tier.sub + '">' + nivelInfo.icon + ' Nivel ' + nivelInfo.nivel + '</div>' : '') +
          '<div style="font-size:10px;color:' + tier.sub + ';margin-top:2px">#' + (pos || '—') + ' de ' + totalUsers + ' participantes</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ── Racha reciente (form guide) ─────────────────────── */
  function _chFormGuide(formHistory) {
    if (!formHistory || formHistory.length === 0) {
      return '<div style="color:var(--ch-muted);font-size:13px;padding:6px 0">Tu racha de aciertos/fallos aparecerá aquí partido a partido.</div>';
    }
    const recent = formHistory.slice(-10);
    const pills = recent.map((h, i) => {
      let bg, border, glyph, color;
      if (h.ok === 2)       { bg = 'var(--ch-gold)';             border = '#ffb8d4'; glyph = '★'; color = '#2a0016'; }
      else if (h.ok === 1)  { bg = 'rgba(34,197,94,0.16)';        border = '#22c55e'; glyph = '✓'; color = '#22c55e'; }
      else if (h.ok === -1) { bg = 'transparent';                 border = '#333';    glyph = '–'; color = 'var(--ch-muted)'; }
      else                  { bg = 'rgba(239,68,68,0.16)';        border = '#ef4444'; glyph = '✕'; color = '#ef4444'; }
      const title = (h.matchday ? 'J' + h.matchday + ': ' : '') + h.home + ' vs ' + h.away + (h.pts > 0 ? ' · +' + h.pts + ' pts' : '');
      const delay = (i * 0.05).toFixed(2);
      return '<div title="' + chEscape(title) + '" style="display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0">' +
        '<div class="sr-ch-fg-pill" style="width:30px;height:30px;border-radius:50%;background:' + bg + ';border:2px solid ' + border + ';' +
          'display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:' + color + ';' +
          'animation-delay:' + delay + 's">' + glyph + '</div>' +
      '</div>';
    }).join('<div style="flex-shrink:0;height:2px;width:10px;background:var(--ch-border);align-self:center"></div>');

    let live = 0;
    for (let i = recent.length - 1; i >= 0; i--) {
      if (recent[i].ok === 1 || recent[i].ok === 2) live++; else break;
    }
    const liveTag = live >= 3
      ? '<div style="margin-top:14px;display:inline-flex;align-items:center;gap:6px;background:rgba(245,158,11,0.12);' +
        'border:1px solid rgba(245,158,11,0.4);border-radius:20px;padding:6px 14px;font-size:12px;color:var(--ch-amber);font-weight:700">' +
        '🔥 ¡' + live + ' aciertos seguidos ahora mismo!</div>'
      : '';

    return '<div style="display:flex;gap:8px;overflow-x:auto;padding:2px 2px 6px">' + pills + '</div>' + liveTag;
  }

  async function _renderMisStats() {
    const cont = document.getElementById('sr-ch-stats-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:40px">Calculando estadísticas...</div>';
    try {
      // Lee solo partidos terminados con filtro (igual que Liga/Knockout)
      let matchSnap;
      try { matchSnap = await _db.collection('matches').where('status', '==', 'finished').get(); }
      catch(e) { throw new Error('matches: ' + e.message); }

      const matches = {}; matchSnap.forEach(d => { matches[d.id] = d.data(); });
      const matchIds = Object.keys(matches);

      // Lee predicciones individualmente por matchId (evita listar la colección)
      const preds = {};
      await Promise.all(matchIds.map(mid =>
        _db.doc('users/' + _user.uid + '/ch_predictions/' + mid).get()
          .then(d => { if (d.exists) preds[mid] = d.data(); })
          .catch(() => {})
      ));

      let allProfiles = [];
      try { allProfiles = await _chGetAllProfiles(); } catch(e) {}

      // Alias, no copia — antes era un 4to objeto hardcodeado con la misma forma
      // exacta que CH_PHASE_PTS_BY_KEY (una de 5 copias de los mismos puntos en
      // todo el proyecto). Al ser el mismo objeto, si _applyPointsConfig() lo muta
      // por una config personalizada del admin, esta pantalla también lo recibe
      // automáticamente sin tener que tocarla.
      const PHASE_PTS = CH_PHASE_PTS_BY_KEY;
      const PHASE_LABELS = { league:'FASE DE LIGA', playoff:'PLAYOFF', r16:'8VOS DE FINAL', qf:'CUARTOS', sf:'SEMIFINALES', final:'GRAN FINAL' };
      const PHASE_COLORS = { league:'#60a5fa', playoff:'#a78bfa', r16:'#22c55e', qf:'#FF1464', sf:'#f59e0b', final:'#ef4444' };
      const PHASE_ORDER  = ['league','playoff','r16','qf','sf','final'];

      // matchIds ya son todos finished; ordenar cronológicamente
      const finishedIds = matchIds
        .filter(mid => matches[mid].homeScore != null)
        .sort((a, b) => {
          const ma = matches[a], mb = matches[b];
          const pa = PHASE_ORDER.indexOf(ma.phase || 'league');
          const pb = PHASE_ORDER.indexOf(mb.phase || 'league');
          if (pa !== pb) return pa - pb;
          return ((ma.matchday||0)*100+(ma.matchOrder||0)) - ((mb.matchday||0)*100+(mb.matchOrder||0));
        });

      let pts = 0, correct = 0, exactos = 0, anotadores = 0;
      let total = 0, streak = 0, maxStreak = 0, cumPts = 0;
      const byPhase = {}, pointHistory = [], formHistory = [];

      finishedIds.forEach(mid => {
        const res = matches[mid], m = matches[mid] || {}, pred = preds[mid];
        const phase = m.phase || 'league', fp = PHASE_PTS[phase] || PHASE_PTS.league;
        const homeTeam = m.homeTeamName || m.local || '?';
        const awayTeam = m.awayTeamName || m.visitante || '?';
        if (!byPhase[phase]) byPhase[phase] = { correct:0, total:0, exactos:0, anotadores:0, pts:0 };
        total++; byPhase[phase].total++;
        if (!pred) {
          streak = 0; pointHistory.push(cumPts);
          formHistory.push({ ok: -1, pts: 0, home: homeTeam, away: awayTeam, matchday: m.matchday });
          return;
        }
        const rH = Number(res.homeScore  ?? res.localScore);
        const rA = Number(res.awayScore  ?? res.visitanteScore);
        const pH = Number(pred.homeScore ?? pred.localScore);
        const pA = Number(pred.awayScore ?? pred.visitanteScore);
        if (isNaN(pH)||isNaN(pA)||isNaN(rH)||isNaN(rA)) {
          pointHistory.push(cumPts);
          formHistory.push({ ok: -1, pts: 0, home: homeTeam, away: awayTeam, matchday: m.matchday });
          return;
        }
        const realRes = rH > rA ? 'H' : rH < rA ? 'A' : 'D';
        const predRes = pH > pA ? 'H' : pH < pA ? 'A' : 'D';
        let mPts = 0, exact = false;
        if (predRes === realRes) {
          mPts += fp.resultado; correct++; byPhase[phase].correct++;
          streak++; if (streak > maxStreak) maxStreak = streak;
          if (pH === rH && pA === rA) { mPts += fp.exacto; exactos++; byPhase[phase].exactos++; exact = true; }
          const pf = pred.firstScoringTeam, rf = res.firstScoringTeam;
          if (pf && rf && pf === rf) { mPts += fp.anotador; anotadores++; byPhase[phase].anotadores++; }
          const rb = CH_DATA.rachas.find(r => streak === r.n);
          if (rb) mPts += rb.bonus;
        } else { streak = 0; }
        pts += mPts; cumPts += mPts; byPhase[phase].pts += mPts;
        pointHistory.push(cumPts);
        formHistory.push({ ok: exact ? 2 : (mPts > 0 ? 1 : 0), pts: mPts, home: homeTeam, away: awayTeam, matchday: m.matchday });
      });

      const nivelInfo = chGetLevel(pts, _chActiveLevels());

      // Ranking — perfiles de todos los usuarios (usa la misma caché de 20s que
      // Dashboard/Ranking en vez de volver a escanear toda la colección users)
      const allUsers = allProfiles.map(p => ({ id: p.uid, pts: p.totalPoints, correctos: p.correctos, maxStreak: p.maxStreak }));
      allUsers.sort((a,b) => b.pts - a.pts);
      const hasRanking = allUsers.length > 0;
      const totalUsers = Math.max(allUsers.length, 1);
      const myRawPos   = allUsers.findIndex(u => u.id === _user.uid);
      const myPos      = myRawPos >= 0 ? myRawPos + 1 : null;
      const leaderPts  = allUsers[0]?.pts || pts;
      const avgPts     = hasRanking ? Math.round(allUsers.reduce((s,u) => s + u.pts, 0) / totalUsers) : 0;
      const beatCount  = allUsers.filter(u => u.id !== _user.uid && u.pts < pts).length;
      const percentile = totalUsers > 1 ? Math.round((beatCount / (totalUsers-1)) * 100) : 0;

      // "El Fantasma" — rival compuesto por el promedio de TODOS LOS DEMÁS participantes
      const mean = arr => arr.length ? arr.reduce((s, v) => s + v, 0) / arr.length : 0;
      const rivals   = allUsers.filter(u => u.id !== _user.uid);
      const ghostPool  = rivals.length ? rivals : allUsers;
      const ghostPts    = Math.round(mean(ghostPool.map(u => u.pts)));
      const ghostAccPct = total > 0 ? Math.round(mean(ghostPool.map(u => (u.correctos / total) * 100))) : 0;
      const ghostStreak = Math.round(mean(ghostPool.map(u => u.maxStreak)) * 10) / 10;

      const pct      = total > 0 ? Math.round((correct    / total) * 100) : 0;
      const exactPct = total > 0 ? Math.round((exactos    / total) * 100) : 0;
      const anotPct  = total > 0 ? Math.round((anotadores / total) * 100) : 0;
      const ligaD    = byPhase.league;
      const ligaPct  = ligaD && ligaD.total > 0 ? Math.round((ligaD.correct / ligaD.total) * 100) : 0;
      const pctColor   = pct >= 60 ? '#22c55e' : pct >= 40 ? '#FF1464' : pct > 0 ? '#ef4444' : '#536080';
      const myPosColor = !myPos ? 'var(--ch-muted)' : myPos === 1 ? '#FF1464' : myPos <= 3 ? '#aaa' : 'var(--ch-text)';
      const myPosStr   = myPos ? '#' + myPos + ' / ' + totalUsers : '—';

      const radarDims = [
        { label:'PRECISION', val: pct },
        { label:'VS LIGA',   val: ligaPct },
        { label:'EXACTOS',   val: Math.min(exactPct  * 3.5, 100) },
        { label:'RACHA',     val: Math.min((maxStreak / 12) * 100, 100) },
        { label:'ANOTADOR',  val: Math.min(anotPct   * 3.5, 100) },
        { label:'PUNTOS',    val: leaderPts > 0 ? Math.min((pts / leaderPts) * 100, 100) : 0 }
      ];

      let html = '';

      // Carta de Jugador (estilo FIFA/FUT) — pieza central nueva
      html += _chPlayerCard(
        (_profile && _profile.displayName) || (_user && _user.displayName) || 'Jugador',
        myPos, totalUsers, total,
        pct, Math.min(exactPct * 3.5, 100), Math.min(anotPct * 3.5, 100), Math.min((maxStreak / 12) * 100, 100), percentile,
        nivelInfo
      );

      // Racha reciente (form guide)
      html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">RACHA RECIENTE</div>' + _chFormGuide(formHistory) + '</div>';

      // KPI Row
      html += '<div class="sr-ch-stats-kpi-row">';
      [
        { icon:'⭐', val: pts,                        label:'PUNTOS TOTALES', col:'#FF1464'   },
        { icon:'📍', val: myPosStr,                    label:'TU POSICIÓN',    col: myPosColor },
        { icon:'✅', val: correct+' / '+total,        label:'ACIERTOS',       col:'#22c55e'   },
        { icon:'🔥', val: maxStreak,                  label:'MEJOR RACHA',    col:'#f59e0b'   }
      ].forEach(k => {
        var kpiNum = (typeof k.val === 'number' || (typeof k.val === 'string' && /^\d+$/.test(k.val))) ? ' data-num="' + k.val + '"' : '';
        html += '<div class="sr-ch-stats-kpi">' +
          '<div class="sr-ch-stats-kpi-icon">' + k.icon + '</div>' +
          '<div class="sr-ch-stats-kpi-val" style="color:' + k.col + '"' + kpiNum + '>' + (kpiNum ? '0' : k.val) + '</div>' +
          '<div class="sr-ch-stats-kpi-label">' + k.label + '</div>' +
        '</div>';
      });
      html += '</div>';

      // Precision + Radar
      html += '<div class="sr-ch-stats-row2">';
      html += '<div class="sr-ch-panel sr-ch-stats-precision-panel">' +
        '<div class="sr-ch-panel-title">PRECISIÓN GENERAL</div>' +
        '<div class="sr-ch-stats-donut-wrap">' +
          '<div class="sr-ch-stats-donut-svg">' +
            _svgDonut(pct, pctColor, 140, 16) +
          '</div>' +
          '<div class="sr-ch-stats-precision-chips">' +
            '<div class="sr-ch-stats-chip"><span class="scp-val" style="color:#22c55e">' + correct + '</span><span class="scp-lbl">ACIERTOS</span></div>' +
            '<div class="sr-ch-stats-chip"><span class="scp-val" style="color:#FF1464">' + exactos + '</span><span class="scp-lbl">EXACTOS</span></div>' +
            '<div class="sr-ch-stats-chip"><span class="scp-val" style="color:#60a5fa">' + anotadores + '</span><span class="scp-lbl">ANOTADORES</span></div>' +
          '</div>' +
        '</div>' +
      '</div>';
      html += '<div class="sr-ch-panel">' +
        '<div class="sr-ch-panel-title">PERFIL DE JUGADOR</div>' +
        '<div class="sr-ch-stats-radar-wrap">' +
          '<canvas id="ch-stats-radar" class="sr-ch-stats-radar-canvas"></canvas>' +
        '</div>' +
      '</div>';
      html += '</div>';

      // Evolution chart
      html += '<div class="sr-ch-panel">' +
        '<div class="sr-ch-panel-title">EVOLUCIÓN DE PUNTOS</div>' +
        '<div class="sr-ch-stats-chart-wrap">' +
          '<canvas id="ch-stats-line" class="sr-ch-stats-line-canvas"></canvas>' +
        '</div>' +
      '</div>';

      // Phase bars + Breakdown
      html += '<div class="sr-ch-stats-row2">';
      html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">RENDIMIENTO POR FASE</div>';
      const hasPhaseData = PHASE_ORDER.some(p => byPhase[p] && byPhase[p].total > 0);
      if (!hasPhaseData) {
        html += '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:20px 0">Sin partidos jugados aún</div>';
      } else {
        PHASE_ORDER.forEach(phase => {
          const s = byPhase[phase]; if (!s || s.total === 0) return;
          const fp  = Math.round((s.correct / s.total) * 100);
          const col = fp >= 60 ? '#22c55e' : fp >= 40 ? '#FF1464' : '#ef4444';
          html += '<div class="sr-ch-stats-phase-bar">' +
            '<div class="sr-ch-stats-phase-top">' +
              '<span class="sr-ch-stats-phase-name">' + (PHASE_LABELS[phase]||phase) + '</span>' +
              '<span class="sr-ch-stats-phase-right">' + s.correct + '/' + s.total + '&nbsp;<strong style="color:' + col + '">' + fp + '%</strong></span>' +
            '</div>' +
            '<div class="sr-ch-stats-bar-bg"><div class="sr-ch-stats-bar-fill" style="width:' + fp + '%;background:' + col + '"></div></div>' +
          '</div>';
        });
      }
      html += '</div>';
      html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">DESGLOSE DE PUNTOS</div>';
      const hasBreakdown = PHASE_ORDER.some(p => byPhase[p] && byPhase[p].pts > 0);
      if (!hasBreakdown) {
        html += '<div style="color:var(--ch-muted);font-size:13px;text-align:center;padding:20px 0">Sin puntos todavía</div>';
      } else {
        html += '<div class="sr-ch-stats-breakdown">';
        PHASE_ORDER.forEach(phase => {
          const s = byPhase[phase]; if (!s || s.pts === 0) return;
          const ppct = pts > 0 ? Math.round((s.pts / pts) * 100) : 0;
          const col  = PHASE_COLORS[phase] || '#FF1464';
          html += '<div class="sr-ch-stats-bk-row">' +
            '<div class="sr-ch-stats-bk-dot" style="background:' + col + '"></div>' +
            '<div class="sr-ch-stats-bk-label">' + (PHASE_LABELS[phase]||phase) + '</div>' +
            '<div class="sr-ch-stats-bk-pts">' + s.pts + '<span class="bk-pts-unit"> pts</span></div>' +
            '<div class="sr-ch-stats-bk-pct" style="color:' + col + '">' + ppct + '%</div>' +
          '</div>';
        });
        html += '</div>';
      }
      html += '</div></div>';

      // Rival Fantasma — duelo por categorías vs el promedio real del grupo
      const maxBar = Math.max(leaderPts, pts, ghostPts, 1);
      const dueloCats = [
        { label: 'PUNTOS',    you: pts,        ghost: ghostPts,    unit: '',  dec: 0 },
        { label: 'PRECISIÓN', you: pct,        ghost: ghostAccPct, unit: '%', dec: 0 },
        { label: 'RACHA',     you: maxStreak,  ghost: ghostStreak, unit: '',  dec: 1 }
      ];
      let ghWins = 0, ghLosses = 0, ghTies = 0;
      const duelRows = dueloCats.map(c => {
        const diff = c.you - c.ghost;
        let icon;
        if (Math.abs(diff) < 0.05) { icon = '➖'; ghTies++; }
        else if (diff > 0)          { icon = '✅'; ghWins++; }
        else                        { icon = '❌'; ghLosses++; }
        return '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:9px 0;' +
          'border-bottom:1px solid var(--ch-border)">' +
          '<span style="font-size:10.5px;letter-spacing:1.5px;color:var(--ch-text2);font-weight:700;flex:1">' + c.label + '</span>' +
          '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;color:var(--ch-text);min-width:44px;text-align:right">' + c.you.toFixed(c.dec) + c.unit + '</span>' +
          '<span style="font-size:16px">' + icon + '</span>' +
          '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:17px;color:var(--ch-muted);min-width:44px">' + c.ghost.toFixed(c.dec) + c.unit + '</span>' +
        '</div>';
      }).join('');
      const verdict = ghWins > ghLosses
        ? { txt: '🏆 LE GANÁS AL FANTASMA (' + ghWins + '-' + ghLosses + (ghTies ? '-' + ghTies : '') + ')', color: '#22c55e' }
        : ghWins < ghLosses
        ? { txt: '👻 EL FANTASMA TE GANA (' + ghLosses + '-' + ghWins + (ghTies ? '-' + ghTies : '') + ')', color: '#ef4444' }
        : { txt: '⚖️ EMPATE TÉCNICO CONTRA EL FANTASMA', color: 'var(--ch-gold)' };

      html += '<div class="sr-ch-panel"><div class="sr-ch-panel-title">🔮 RIVAL FANTASMA — VOS VS "EL PROMEDIO"</div>' +
        '<div class="sr-ch-stats-row2">' +
        '<div>' +
          '<div class="sr-ch-stats-vsgroup">';
      [
        { label:'Lider',    val: leaderPts, col:'#FF1464' },
        { label:'Vos',      val: pts,       col:'#22c55e' },
        { label:'Fantasma', val: ghostPts,  col:'#536080' }
      ].forEach(row => {
        const bw = row.val > 0 ? Math.max((row.val / maxBar) * 100, 3) : 0;
        html += '<div class="sr-ch-stats-vs-row">' +
          '<div class="sr-ch-stats-vs-label">' + row.label + '</div>' +
          '<div class="sr-ch-stats-vs-bar-wrap"><div class="sr-ch-stats-vs-bar" style="width:' + bw + '%;background:' + row.col + '"></div></div>' +
          '<div class="sr-ch-stats-vs-val">' + row.val + ' pts</div>' +
        '</div>';
      });
      html += '<div class="sr-ch-stats-percentile">' +
        '<span class="sr-ch-stats-perc-num">' + percentile + 'TH</span>' +
        '<span class="sr-ch-stats-perc-label">Mejor que el <strong>' + percentile + '%</strong> del grupo</span>' +
      '</div>' +
        '</div>' +
        '<div>' +
          '<div style="font-size:9px;letter-spacing:2px;color:var(--ch-muted);margin-bottom:2px;text-transform:uppercase">Duelo por categoría</div>' +
          duelRows +
          '<div style="margin-top:14px;text-align:center;padding:10px;border-radius:10px;background:rgba(255,255,255,0.03);' +
            'border:1px solid var(--ch-border);font-size:12px;font-weight:700;color:' + verdict.color + '">' + verdict.txt + '</div>' +
        '</div>' +
        '</div>' +
      '</div>';

      cont.innerHTML = html;

      requestAnimationFrame(() => {
        // Animar donut arc
        const arc = cont.querySelector('.sr-ch-donut-arc');
        if (arc) requestAnimationFrame(() => { arc.style.strokeDashoffset = arc.dataset.target; });
        // Dibujar charts
        _drawRadarChart('ch-stats-radar', radarDims);
        _drawLineChart('ch-stats-line', pointHistory);
        // Count-up en KPI numéricos
        const kpiVals = cont.querySelectorAll('.sr-ch-stats-kpi-val[data-num]');
        kpiVals.forEach(el => chCountUp(el, parseInt(el.dataset.num, 10), 900));
        // Count-up del OVR de la carta de jugador
        const ovrEl = cont.querySelector('#ch-pcard-ovr[data-num]');
        if (ovrEl) chCountUp(ovrEl, parseInt(ovrEl.dataset.num, 10), 1100);
        // Ripple y tilt
        chInitRipples(cont); chInitTilt(cont);
      });

    } catch(err) {
      console.error('[CHStats]', err);
      cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:40px">Error al cargar estadísticas. Intentá de nuevo.</div>';
    }
    renderSponsorStrip();
  }

  /* ── Medallas ──────────────────────────────────────── */
  /* ── Salón de la Fama ── */
  async function _renderFama() {
    const cont = document.getElementById('sr-ch-fama-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:30px;font-size:13px">Cargando...</div>';
    try {
      const snap = await _db.collection('champions_halloffame').get();
      const entries = [];
      snap.forEach(d => entries.push(d.data()));
      entries.sort((a, b) => (a.order || 0) - (b.order || 0));

      if (entries.length === 0) {
        cont.innerHTML =
          '<div class="sr-ch-fama-empty">' +
            '<span class="sr-ch-fama-empty-icon">🏛️</span>' +
            '<div class="sr-ch-fama-empty-title">Todavía no hay temporadas completadas</div>' +
            '<div class="sr-ch-fama-empty-sub">Cuando termine esta temporada, acá vas a ver a los campeones — ¡vos podés ser el primer nombre!</div>' +
          '</div>';
        return;
      }

      cont.innerHTML = entries.map(f =>
        '<div class="sr-ch-fama-row">' +
          '<span class="sr-ch-fama-icon">' + chEscape(f.icon || '🏆') + '</span>' +
          '<div class="sr-ch-fama-info">' +
            '<div class="sr-ch-fama-season">' + chEscape(f.season || '') + '</div>' +
            '<div class="sr-ch-fama-name">' + chEscape(f.participantName || '') + '</div>' +
            '<div class="sr-ch-fama-achievement">' + chEscape(f.achievement || '') + (f.points ? ' · ' + f.points + ' pts' : '') + '</div>' +
          '</div>' +
        '</div>'
      ).join('');
    } catch(e) {
      cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:30px;font-size:13px">Error al cargar.</div>';
    }
  }

  async function _renderMedallas() {
    const cont = document.getElementById('sr-ch-medals-content');
    if (!cont) return;
    cont.innerHTML = '<div style="color:var(--ch-muted);text-align:center;padding:30px;font-size:13px;grid-column:1/-1">Cargando...</div>';

    const pts = _profile.totalPoints || 0;
    const correct = _profile.correctos || 0;
    const exactos = _profile.exactos || 0;
    const maxStreak = _profile.maxStreak || 0;

    // finalPredicted y fullJornada nunca se calculan en NINGÚN otro lado del código (ni
    // acá ni en el admin) — se inicializan en false al registrarse y nada las vuelve a
    // tocar jamás, así que esas 2 medallas eran estructuralmente imposibles de ganar.
    // Se calculan en vivo: ¿el usuario predijo la Gran Final (id fijo 'final_match')? ¿y
    // completó TODAS las predicciones de al menos una jornada de liga?
    let finalPredicted = false;
    let fullJornada = false;
    try {
      const [finalPredDoc, matchSnap, predSnap] = await Promise.all([
        _db.doc('users/' + _user.uid + '/ch_predictions/final_match').get(),
        _db.collection('matches').where('phase', '==', 'league').get(),
        _db.collection('users/' + _user.uid + '/ch_predictions').get()
      ]);
      finalPredicted = finalPredDoc.exists;

      const predictedIds = {};
      predSnap.forEach(d => { predictedIds[d.id] = true; });
      const totalPorJornada = {}, prediPorJornada = {};
      matchSnap.forEach(doc => {
        const md = doc.data().matchday;
        if (!md) return;
        totalPorJornada[md] = (totalPorJornada[md] || 0) + 1;
        if (predictedIds[doc.id]) prediPorJornada[md] = (prediPorJornada[md] || 0) + 1;
      });
      fullJornada = Object.keys(totalPorJornada).some(md =>
        totalPorJornada[md] > 0 && prediPorJornada[md] === totalPorJornada[md]
      );
    } catch(e) { /* si falla, quedan en false — no bloquea el resto de las medallas */ }

    const stats = { pts, correct, exactos, maxStreak, finalPredicted, fullJornada };

    cont.innerHTML = CH_DATA.medallas.map(med => {
      const earned = med.check(stats);
      return '<div class="sr-ch-medal' + (earned ? ' earned' : ' locked') + '">' +
        '<div class="sr-ch-medal-icon">' + med.icon + '</div>' +
        '<div class="sr-ch-medal-name">' + chEscape(med.nombre) + '</div>' +
        '<div class="sr-ch-medal-desc">' + chEscape(med.desc) + '</div>' +
      '</div>';
    }).join('');
    renderSponsorStrip();
  }

  /* ── Public API ────────────────────────────────────── */
  return {
    init, login, register, logout, showForgot, sendReset, toggleForm, togglePasswordVisibility,
    showHowItWorksModal, closeHowItWorksModal, toggleSound, shareMatchPrediction, closeSharePredModal,
    dismissAnnouncement, searchDuel, toggleQuickMode, saveAllQuick,
    showScreen, loadJornada, loadFaseElim, savePred, saveQualifier, navToBracketMatch, scrollToMyRank,
    sponsorClick, bannerClick, _bannerGoTo
  };

})();

/* ── Iniciar cuando el DOM esté listo ─────────────────── */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ChampionsApp.init());
} else {
  ChampionsApp.init();
}
